// Extracted from wrath .babylon file
// 3 mesh(es), 3 material(s), generated 2025-12-25
// Transforms are baked into vertex positions

import type { RuneMesh, RuneMaterials } from "./types.js";

export const WRATH_MATERIALS: RuneMaterials = [
  {
    name: "02___Default",
    albedoColor: [0.21570000, 0.21570000, 0.21570000],
    metallic: 0.00000000,
    roughness: 0.89999998,
  },
  {
    name: "01___Default",
    albedoColor: [0.04710000, 0.04710000, 0.04710000],
    metallic: 0.00000000,
    roughness: 0.89999998,
  },
  {
    name: "03___Default",
    albedoColor: [0.21960001, 0.00000000, 0.12549999],
    metallic: 0.00000000,
    roughness: 0.89999998,
  },
];

const WRATH_MESH_0: RuneMesh = {
  name: "Wrath_Rune_primitive0",
  positions: new Float32Array([
    -0.79460001, 0.43309999, -0.00000003,
    -0.83679998, 0.42829999, -0.00000003,
    -0.81849998, 0.42829999, -0.17400002,
    -0.77719998, 0.43309999, -0.16520002,
    -0.72589999, 0.43309996, -0.32320002,
    -0.64289999, 0.43309996, -0.46710002,
    -0.53170002, 0.43309996, -0.59050006,
    -0.39730000, 0.43309993, -0.68820006,
    -0.24550000, 0.43309993, -0.75570005,
    -0.08310000, 0.43309993, -0.79030007,
    0.08310000, 0.43309993, -0.79030007,
    0.24550000, 0.43309993, -0.75570005,
    0.39730000, 0.43309993, -0.68820006,
    0.53170002, 0.43309996, -0.59050006,
    0.64289999, 0.43309996, -0.46710002,
    0.72589999, 0.43309996, -0.32320002,
    0.77719998, 0.43309999, -0.16520002,
    0.67430001, 0.43309996, -0.20730004,
    0.67430001, 0.43309996, -0.20730004,
    0.53740001, 0.43309996, -0.39230004,
    0.53740001, 0.43309996, -0.39230004,
    0.29960001, 0.43309996, -0.25060004,
    0.29960001, 0.43309996, -0.25060004,
    0.16990000, 0.43309996, -0.38510004,
    0.16990000, 0.43309996, -0.38510004,
    0.02820000, 0.43309996, -0.43550003,
    0.02820000, 0.43309996, -0.43550003,
    0.02820000, 0.43309996, -0.43550003,
    -0.12080000, 0.43309996, -0.44030002,
    -0.12080000, 0.43309996, -0.44030002,
    -0.26010001, 0.43309996, -0.30340004,
    -0.26010001, 0.43309996, -0.30340004,
    -0.49070001, 0.43309996, -0.44030002,
    -0.49070001, 0.43309996, -0.44030002,
    -0.63480002, 0.43309996, -0.24820003,
    -0.63480002, 0.43309996, -0.24820003,
    -0.68279999, 0.43309999, -0.01040003,
    -0.68279999, 0.43309999, -0.01040003,
    -0.68040001, 0.43310001, 0.26109996,
    -0.68040001, 0.43310001, 0.26109996,
    -0.38980001, 0.43310001, 0.44839996,
    -0.38980001, 0.43310001, 0.44839996,
    -0.49070001, 0.43310001, 0.20339997,
    -0.49070001, 0.43310001, 0.20339997,
    -0.49070001, 0.43310001, 0.20339997,
    -0.48590001, 0.43309999, 0.06409997,
    -0.48590001, 0.43309999, 0.06409997,
    -0.39460000, 0.43309999, -0.02240003,
    -0.39460000, 0.43309999, -0.02240003,
    -0.34650001, 0.43309999, 0.12649997,
    -0.34650001, 0.43309999, 0.12649997,
    -0.25529999, 0.43309999, 0.16499998,
    -0.25529999, 0.43309999, 0.16499998,
    -0.30329999, 0.43310001, 0.40039998,
    -0.30329999, 0.43310001, 0.40039998,
    -0.11600000, 0.43310001, 0.30429998,
    -0.11600000, 0.43310001, 0.30429998,
    -0.11600000, 0.43310001, 0.30429998,
    -0.02470000, 0.43310001, 0.48919997,
    -0.02470000, 0.43310001, 0.48919997,
    0.07140000, 0.43310001, 0.35229996,
    0.07140000, 0.43310001, 0.35229996,
    0.25870001, 0.43310001, 0.44359997,
    0.25870001, 0.43310001, 0.44359997,
    0.20829999, 0.43310001, 0.21059997,
    0.20829999, 0.43310001, 0.21059997,
    0.30919999, 0.43309999, 0.16019997,
    0.30919999, 0.43309999, 0.16019997,
    0.39080000, 0.43309999, 0.03049997,
    0.39080000, 0.43309999, 0.03049997,
    0.43410000, 0.43309999, 0.10969997,
    0.43410000, 0.43309999, 0.10969997,
    0.44130000, 0.43310001, 0.24659997,
    0.44130000, 0.43310001, 0.24659997,
    0.34279999, 0.43310001, 0.49159998,
    0.34279999, 0.43310001, 0.49159998,
    0.62379998, 0.43310001, 0.30669996,
    0.62379998, 0.43310001, 0.30669996,
    0.67189997, 0.43309999, 0.03529997,
    0.67189997, 0.43309999, 0.03529997,
    0.79460001, 0.43309999, -0.00000003,
    0.77719998, 0.43309999, 0.16519997,
    0.72589999, 0.43310001, 0.32319996,
    0.64289999, 0.43310001, 0.46709996,
    0.53170002, 0.43310001, 0.59049994,
    0.39730000, 0.43310004, 0.68809992,
    0.24550000, 0.43310004, 0.75569993,
    0.08310000, 0.43310004, 0.79029995,
    -0.08310000, 0.43310004, 0.79029995,
    -0.24550000, 0.43310004, 0.75569993,
    -0.39730000, 0.43310004, 0.68809992,
    -0.53170002, 0.43310001, 0.59049994,
    -0.64289999, 0.43310001, 0.46709996,
    -0.72589999, 0.43310001, 0.32319996,
    -0.77719998, 0.43309999, 0.16519997,
    -0.81849998, 0.42829999, 0.17399997,
    -0.87690002, 0.41429999, -0.00000003,
    -0.85769999, 0.41429999, -0.18230003,
    -0.76450002, 0.42829996, -0.34040004,
    -0.67699999, 0.42829996, -0.49190003,
    -0.55989999, 0.42829993, -0.62190008,
    -0.41839999, 0.42829993, -0.72470003,
    -0.25860000, 0.42829993, -0.79590005,
    -0.08750000, 0.42829993, -0.83220005,
    0.08750000, 0.42829993, -0.83220005,
    0.25860000, 0.42829993, -0.79590005,
    0.41839999, 0.42829993, -0.72470003,
    0.55989999, 0.42829993, -0.62190008,
    0.67699999, 0.42829996, -0.49190003,
    0.76450002, 0.42829996, -0.34040004,
    0.81849998, 0.42829999, -0.17400002,
    0.83679998, 0.42829999, -0.00000003,
    0.81849998, 0.42829999, 0.17399997,
    0.76450002, 0.42830002, 0.34039998,
    0.67699999, 0.42830002, 0.49189997,
    0.55989999, 0.42830005, 0.62189996,
    0.41839999, 0.42830005, 0.72469991,
    0.25860000, 0.42830005, 0.79579991,
    0.08750000, 0.42830005, 0.83219993,
    -0.08750000, 0.42830005, 0.83219993,
    -0.25860000, 0.42830005, 0.79579991,
    -0.41839999, 0.42830005, 0.72469991,
    -0.55989999, 0.42830005, 0.62189996,
    -0.67699999, 0.42830002, 0.49189997,
    -0.76450002, 0.42830002, 0.34039998,
    -0.85769999, 0.41429999, 0.18229997,
    -0.91280001, 0.39170000, -0.00000003,
    -0.89289999, 0.39170000, -0.18980002,
    -0.80110002, 0.41429996, -0.35670003,
    -0.70940000, 0.41429996, -0.51540005,
    -0.58679998, 0.41429994, -0.65170008,
    -0.43840000, 0.41429994, -0.75940007,
    -0.27100000, 0.41429994, -0.83400005,
    -0.09170000, 0.41429994, -0.87210006,
    0.09170000, 0.41429994, -0.87210006,
    0.27100000, 0.41429994, -0.83400005,
    0.43840000, 0.41429994, -0.75940007,
    0.58679998, 0.41429994, -0.65170008,
    0.70940000, 0.41429996, -0.51540005,
    0.80110002, 0.41429996, -0.35670003,
    0.85769999, 0.41429999, -0.18230003,
    0.87690002, 0.41429999, -0.00000003,
    0.85769999, 0.41429999, 0.18229997,
    0.80110002, 0.41430002, 0.35669997,
    0.70940000, 0.41430002, 0.51539993,
    0.58679998, 0.41430005, 0.65169996,
    0.43840000, 0.41430005, 0.75939995,
    0.27100000, 0.41430005, 0.83399993,
    0.09170000, 0.41430005, 0.87209994,
    -0.09170000, 0.41430005, 0.87209994,
    -0.27100000, 0.41430005, 0.83399993,
    -0.43840000, 0.41430005, 0.75939995,
    -0.58679998, 0.41430005, 0.65169996,
    -0.70940000, 0.41430002, 0.51539993,
    -0.80110002, 0.41430002, 0.35669997,
    -0.89289999, 0.39170000, 0.18979996,
    -0.94290000, 0.36170000, -0.00000003,
    -0.92229998, 0.36170000, -0.19600002,
    -0.83389997, 0.39169997, -0.37130004,
    -0.73850000, 0.39169997, -0.53659999,
    -0.61080003, 0.39169994, -0.67839998,
    -0.45640001, 0.39169994, -0.79060000,
    -0.28209999, 0.39169994, -0.86820000,
    -0.09540000, 0.39169994, -0.90789998,
    0.09540000, 0.39169994, -0.90789998,
    0.28209999, 0.39169994, -0.86820000,
    0.45640001, 0.39169994, -0.79060000,
    0.61080003, 0.39169994, -0.67839998,
    0.73850000, 0.39169997, -0.53659999,
    0.83389997, 0.39169997, -0.37130004,
    0.89289999, 0.39170000, -0.18980002,
    0.91280001, 0.39170000, -0.00000003,
    0.89289999, 0.39170000, 0.18979996,
    0.83389997, 0.39170003, 0.37129998,
    0.73850000, 0.39170003, 0.53659999,
    0.61080003, 0.39170006, 0.67839998,
    0.45640001, 0.39170006, 0.79049999,
    0.28209999, 0.39170006, 0.86820000,
    0.09540000, 0.39170006, 0.90780002,
    -0.09540000, 0.39170006, 0.90780002,
    -0.28209999, 0.39170006, 0.86820000,
    -0.45640001, 0.39170006, 0.79049999,
    -0.61080003, 0.39170006, 0.67839998,
    -0.73850000, 0.39170003, 0.53659999,
    -0.83389997, 0.39170003, 0.37129998,
    -0.92229998, 0.36170000, 0.19599997,
    -0.96550000, 0.32570001, -0.00000002,
    -0.94440001, 0.32569999, -0.20070003,
    -0.86140001, 0.36169997, -0.38350004,
    -0.76279998, 0.36169997, -0.55419999,
    -0.63090003, 0.36169994, -0.70069999,
    -0.47139999, 0.36169994, -0.81660002,
    -0.29139999, 0.36169994, -0.89670002,
    -0.09860000, 0.36169994, -0.93769997,
    0.09860000, 0.36169994, -0.93769997,
    0.29139999, 0.36169994, -0.89670002,
    0.47139999, 0.36169994, -0.81660002,
    0.63090003, 0.36169994, -0.70069999,
    0.76279998, 0.36169997, -0.55419999,
    0.86140001, 0.36169997, -0.38350004,
    0.92229998, 0.36170000, -0.19600002,
    0.94290000, 0.36170000, -0.00000003,
    0.92229998, 0.36170000, 0.19599997,
    0.86140001, 0.36170003, 0.38349998,
    0.76279998, 0.36170003, 0.55419999,
    0.63090003, 0.36170006, 0.70069999,
    0.47139999, 0.36170006, 0.81660002,
    0.29139999, 0.36170006, 0.89670002,
    0.09860000, 0.36170006, 0.93769997,
    -0.09860000, 0.36170006, 0.93769997,
    -0.29139999, 0.36170006, 0.89670002,
    -0.47139999, 0.36170006, 0.81660002,
    -0.63090003, 0.36170006, 0.70069999,
    -0.76279998, 0.36170003, 0.55419999,
    -0.86140001, 0.36170003, 0.38349998,
    -0.94440001, 0.32570004, 0.20069997,
    -0.97950000, 0.28560001, -0.00000002,
    -0.95810002, 0.28559998, -0.20370002,
    -0.88200003, 0.32569999, -0.39270002,
    -0.78109998, 0.32569999, -0.56750000,
    -0.64600003, 0.32569996, -0.71749997,
    -0.48269999, 0.32569996, -0.83609998,
    -0.29830000, 0.32569996, -0.91820002,
    -0.10090000, 0.32569996, -0.96020001,
    0.10090000, 0.32569996, -0.96020001,
    0.29830000, 0.32569996, -0.91820002,
    0.48269999, 0.32569996, -0.83609998,
    0.64600003, 0.32569996, -0.71749997,
    0.78109998, 0.32569999, -0.56750000,
    0.88200003, 0.32569999, -0.39270002,
    0.94440001, 0.32569999, -0.20070003,
    0.96550000, 0.32570001, -0.00000002,
    0.94440001, 0.32570004, 0.20069997,
    0.88200003, 0.32570004, 0.39269996,
    0.78109998, 0.32570004, 0.56750000,
    0.64600003, 0.32570007, 0.71749997,
    0.48269999, 0.32570007, 0.83609998,
    0.29830000, 0.32570007, 0.91820002,
    0.10090000, 0.32570007, 0.96020001,
    -0.10090000, 0.32570007, 0.96020001,
    -0.29830000, 0.32570007, 0.91820002,
    -0.48269999, 0.32570007, 0.83609998,
    -0.64600003, 0.32570007, 0.71749997,
    -0.78109998, 0.32570004, 0.56750000,
    -0.88200003, 0.32570004, 0.39269996,
    -0.95810002, 0.28560004, 0.20359999,
    -0.98430002, 0.24339999, -0.00000002,
    -0.98430002, 0.24339999, -0.00000002,
    -0.98430002, 0.24339999, -0.00000002,
    -0.96270001, 0.24339998, -0.20460002,
    -0.96270001, 0.24339998, -0.20460002,
    -0.89480001, 0.28559998, -0.39840004,
    -0.79240000, 0.28559998, -0.57569999,
    -0.65539998, 0.28559995, -0.72790003,
    -0.48969999, 0.28559995, -0.84829998,
    -0.30270001, 0.28559995, -0.93159997,
    -0.10240000, 0.28559995, -0.97409999,
    0.10240000, 0.28559995, -0.97409999,
    0.30270001, 0.28559995, -0.93159997,
    0.48969999, 0.28559995, -0.84829998,
    0.65539998, 0.28559995, -0.72790003,
    0.79240000, 0.28559998, -0.57569999,
    0.89480001, 0.28559998, -0.39840004,
    0.95810002, 0.28559998, -0.20370002,
    0.97950000, 0.28560001, -0.00000002,
    0.95810002, 0.28560004, 0.20359999,
    0.89480001, 0.28560004, 0.39839998,
    0.79240000, 0.28560004, 0.57569999,
    0.65539998, 0.28560007, 0.72790003,
    0.48969999, 0.28560007, 0.84829998,
    0.30270001, 0.28560007, 0.93159997,
    0.10240000, 0.28560007, 0.97409999,
    -0.10240000, 0.28560007, 0.97409999,
    -0.30270001, 0.28560007, 0.93159997,
    -0.48980001, 0.28560007, 0.84829998,
    -0.65539998, 0.28560007, 0.72790003,
    -0.79240000, 0.28560004, 0.57569999,
    -0.89480001, 0.28560004, 0.39839998,
    -0.96270001, 0.24340001, 0.20459999,
    -0.96270001, 0.24340001, 0.20459999,
    -0.98430002, 0.21650000, -0.00000002,
    -0.98430002, 0.21650000, -0.00000002,
    -0.96270001, 0.21649998, -0.20460002,
    -0.89920002, 0.24339996, -0.40030003,
    -0.89920002, 0.24339996, -0.40030003,
    -0.79629999, 0.24339995, -0.57849997,
    -0.79629999, 0.24339995, -0.57849997,
    -0.65859997, 0.24339993, -0.73140001,
    -0.65859997, 0.24339993, -0.73140001,
    -0.49210000, 0.24339993, -0.85240000,
    -0.49210000, 0.24339993, -0.85240000,
    -0.30419999, 0.24339992, -0.93610001,
    -0.30419999, 0.24339992, -0.93610001,
    -0.10290000, 0.24339992, -0.97890002,
    -0.10290000, 0.24339992, -0.97890002,
    0.10290000, 0.24339992, -0.97890002,
    0.10290000, 0.24339992, -0.97890002,
    0.30419999, 0.24339992, -0.93610001,
    0.30419999, 0.24339992, -0.93610001,
    0.49210000, 0.24339993, -0.85240000,
    0.49210000, 0.24339993, -0.85240000,
    0.65859997, 0.24339993, -0.73140001,
    0.65859997, 0.24339993, -0.73140001,
    0.79629999, 0.24339995, -0.57849997,
    0.79629999, 0.24339995, -0.57849997,
    0.89920002, 0.24339996, -0.40030003,
    0.89920002, 0.24339996, -0.40030003,
    0.96270001, 0.24339998, -0.20460002,
    0.96270001, 0.24339998, -0.20460002,
    0.98430002, 0.24339999, -0.00000002,
    0.98430002, 0.24339999, -0.00000002,
    0.96270001, 0.24340001, 0.20459999,
    0.96270001, 0.24340001, 0.20459999,
    0.89920002, 0.24340002, 0.40029997,
    0.89920002, 0.24340002, 0.40029997,
    0.79629999, 0.24340004, 0.57849997,
    0.79629999, 0.24340004, 0.57849997,
    0.65859997, 0.24340005, 0.73140001,
    0.65859997, 0.24340005, 0.73140001,
    0.49210000, 0.24340005, 0.85240000,
    0.49210000, 0.24340005, 0.85240000,
    0.30410001, 0.24340007, 0.93610001,
    0.30410001, 0.24340007, 0.93610001,
    0.10290000, 0.24340007, 0.97890002,
    0.10290000, 0.24340007, 0.97890002,
    -0.10290000, 0.24340007, 0.97890002,
    -0.10290000, 0.24340007, 0.97890002,
    -0.30419999, 0.24340007, 0.93610001,
    -0.30419999, 0.24340007, 0.93610001,
    -0.49210000, 0.24340005, 0.85240000,
    -0.49210000, 0.24340005, 0.85240000,
    -0.65859997, 0.24340005, 0.73140001,
    -0.65859997, 0.24340005, 0.73140001,
    -0.79629999, 0.24340004, 0.57849997,
    -0.79629999, 0.24340004, 0.57849997,
    -0.89920002, 0.24340002, 0.40029997,
    -0.89920002, 0.24340002, 0.40029997,
    -0.96270001, 0.21650001, 0.20459999,
    -0.98430002, 0.18960001, -0.00000001,
    -0.98430002, 0.18960001, -0.00000001,
    -0.98430002, 0.18960001, -0.00000001,
    -0.96270001, 0.18959999, -0.20460002,
    -0.96270001, 0.18959999, -0.20460002,
    -0.89920002, 0.21649997, -0.40030003,
    -0.79629999, 0.21649995, -0.57849997,
    -0.65859997, 0.21649994, -0.73140001,
    -0.49210000, 0.21649994, -0.85240000,
    -0.30419999, 0.21649992, -0.93610001,
    -0.10290000, 0.21649992, -0.97890002,
    0.10290000, 0.21649992, -0.97890002,
    0.30419999, 0.21649992, -0.93610001,
    0.49210000, 0.21649994, -0.85240000,
    0.65859997, 0.21649994, -0.73140001,
    0.79629999, 0.21649995, -0.57849997,
    0.89920002, 0.21649997, -0.40030003,
    0.96270001, 0.21649998, -0.20460002,
    0.98430002, 0.21650000, -0.00000002,
    0.96270001, 0.21650001, 0.20459999,
    0.89920002, 0.21650003, 0.40029997,
    0.79629999, 0.21650004, 0.57849997,
    0.65859997, 0.21650006, 0.73140001,
    0.49210000, 0.21650006, 0.85240000,
    0.30410001, 0.21650007, 0.93610001,
    0.10290000, 0.21650007, 0.97890002,
    -0.10290000, 0.21650007, 0.97890002,
    -0.30419999, 0.21650007, 0.93610001,
    -0.49210000, 0.21650006, 0.85240000,
    -0.65859997, 0.21650006, 0.73140001,
    -0.79629999, 0.21650004, 0.57849997,
    -0.89920002, 0.21650003, 0.40029997,
    -0.96270001, 0.18960002, 0.20459999,
    -0.96270001, 0.18960002, 0.20459999,
    -0.97950000, 0.14740001, -0.00000001,
    -0.95810002, 0.14739999, -0.20370002,
    -0.89920002, 0.18959998, -0.40030000,
    -0.89920002, 0.18959998, -0.40030000,
    -0.79629999, 0.18959996, -0.57849997,
    -0.79629999, 0.18959996, -0.57849997,
    -0.65859997, 0.18959995, -0.73140001,
    -0.65859997, 0.18959995, -0.73140001,
    -0.49210000, 0.18959995, -0.85240000,
    -0.49210000, 0.18959995, -0.85240000,
    -0.30419999, 0.18959993, -0.93610001,
    -0.30419999, 0.18959993, -0.93610001,
    -0.10290000, 0.18959993, -0.97890002,
    -0.10290000, 0.18959993, -0.97890002,
    0.10290000, 0.18959993, -0.97890002,
    0.10290000, 0.18959993, -0.97890002,
    0.30419999, 0.18959993, -0.93610001,
    0.30419999, 0.18959993, -0.93610001,
    0.49210000, 0.18959995, -0.85240000,
    0.49210000, 0.18959995, -0.85240000,
    0.65859997, 0.18959995, -0.73140001,
    0.65859997, 0.18959995, -0.73140001,
    0.79629999, 0.18959996, -0.57849997,
    0.79629999, 0.18959996, -0.57849997,
    0.89920002, 0.18959998, -0.40030000,
    0.89920002, 0.18959998, -0.40030000,
    0.96270001, 0.18959999, -0.20460002,
    0.96270001, 0.18959999, -0.20460002,
    0.98430002, 0.18960001, -0.00000001,
    0.98430002, 0.18960001, -0.00000001,
    0.96270001, 0.18960002, 0.20459999,
    0.96270001, 0.18960002, 0.20459999,
    0.89920002, 0.18960004, 0.40030000,
    0.89920002, 0.18960004, 0.40030000,
    0.79629999, 0.18960005, 0.57849997,
    0.79629999, 0.18960005, 0.57849997,
    0.65859997, 0.18960007, 0.73140001,
    0.65859997, 0.18960007, 0.73140001,
    0.49210000, 0.18960007, 0.85240000,
    0.49210000, 0.18960007, 0.85240000,
    0.30410001, 0.18960008, 0.93610001,
    0.30410001, 0.18960008, 0.93610001,
    0.10290000, 0.18960008, 0.97890002,
    0.10290000, 0.18960008, 0.97890002,
    -0.10290000, 0.18960008, 0.97890002,
    -0.10290000, 0.18960008, 0.97890002,
    -0.30419999, 0.18960008, 0.93610001,
    -0.30419999, 0.18960008, 0.93610001,
    -0.49210000, 0.18960007, 0.85240000,
    -0.49210000, 0.18960007, 0.85240000,
    -0.65859997, 0.18960007, 0.73140001,
    -0.65859997, 0.18960007, 0.73140001,
    -0.79629999, 0.18960005, 0.57849997,
    -0.79629999, 0.18960005, 0.57849997,
    -0.89920002, 0.18960004, 0.40030000,
    -0.89920002, 0.18960004, 0.40030000,
    -0.95810002, 0.14740002, 0.20359999,
    -0.96550000, 0.10740000, -0.00000001,
    -0.94440001, 0.10739999, -0.20070001,
    -0.89480001, 0.14739998, -0.39840001,
    -0.79240000, 0.14739996, -0.57569999,
    -0.65539998, 0.14739995, -0.72790003,
    -0.48969999, 0.14739995, -0.84829998,
    -0.30270001, 0.14739993, -0.93159997,
    -0.10240000, 0.14739993, -0.97409999,
    0.10240000, 0.14739993, -0.97409999,
    0.30270001, 0.14739993, -0.93159997,
    0.48969999, 0.14739995, -0.84829998,
    0.65539998, 0.14739995, -0.72790003,
    0.79240000, 0.14739996, -0.57569999,
    0.89480001, 0.14739998, -0.39840001,
    0.95810002, 0.14739999, -0.20370002,
    0.97950000, 0.14740001, -0.00000001,
    0.95810002, 0.14740002, 0.20359999,
    0.89480001, 0.14740004, 0.39840001,
    0.79240000, 0.14740005, 0.57569999,
    0.65539998, 0.14740007, 0.72790003,
    0.48969999, 0.14740007, 0.84829998,
    0.30270001, 0.14740008, 0.93159997,
    0.10240000, 0.14740008, 0.97409999,
    -0.10240000, 0.14740008, 0.97409999,
    -0.30270001, 0.14740008, 0.93159997,
    -0.48980001, 0.14740007, 0.84829998,
    -0.65539998, 0.14740007, 0.72790003,
    -0.79240000, 0.14740005, 0.57569999,
    -0.89480001, 0.14740004, 0.39840001,
    -0.94440001, 0.10740001, 0.20069999,
    -0.94290000, 0.07140000, -0.00000001,
    -0.92229998, 0.07139999, -0.19599999,
    -0.88200003, 0.10739997, -0.39269999,
    -0.78109998, 0.10739996, -0.56750000,
    -0.64600003, 0.10739995, -0.71749997,
    -0.48269999, 0.10739994, -0.83609998,
    -0.29830000, 0.10739993, -0.91820002,
    -0.10090000, 0.10739993, -0.96020001,
    0.10090000, 0.10739993, -0.96020001,
    0.29830000, 0.10739993, -0.91820002,
    0.48269999, 0.10739994, -0.83609998,
    0.64600003, 0.10739995, -0.71749997,
    0.78109998, 0.10739996, -0.56750000,
    0.88200003, 0.10739997, -0.39269999,
    0.94440001, 0.10739999, -0.20070001,
    0.96550000, 0.10740000, -0.00000001,
    0.94440001, 0.10740001, 0.20069999,
    0.88200003, 0.10740003, 0.39269999,
    0.78109998, 0.10740004, 0.56750000,
    0.64600003, 0.10740005, 0.71749997,
    0.48269999, 0.10740006, 0.83609998,
    0.29830000, 0.10740007, 0.91820002,
    0.10090000, 0.10740007, 0.96020001,
    -0.10090000, 0.10740007, 0.96020001,
    -0.29830000, 0.10740007, 0.91820002,
    -0.48269999, 0.10740006, 0.83609998,
    -0.64600003, 0.10740005, 0.71749997,
    -0.78109998, 0.10740004, 0.56750000,
    -0.88200003, 0.10740003, 0.39269999,
    -0.92229998, 0.07140002, 0.19599999,
    -0.91280001, 0.04140000, -0.00000000,
    -0.89289999, 0.04139999, -0.18979999,
    -0.86140001, 0.07139997, -0.38350001,
    -0.76279998, 0.07139996, -0.55419999,
    -0.63090003, 0.07139995, -0.70069999,
    -0.47139999, 0.07139994, -0.81660002,
    -0.29139999, 0.07139993, -0.89670002,
    -0.09860000, 0.07139993, -0.93769997,
    0.09860000, 0.07139993, -0.93769997,
    0.29139999, 0.07139993, -0.89670002,
    0.47139999, 0.07139994, -0.81660002,
    0.63090003, 0.07139995, -0.70069999,
    0.76279998, 0.07139996, -0.55419999,
    0.86140001, 0.07139997, -0.38350001,
    0.92229998, 0.07139999, -0.19599999,
    0.94290000, 0.07140000, -0.00000001,
    0.92229998, 0.07140002, 0.19599999,
    0.86140001, 0.07140003, 0.38350001,
    0.76279998, 0.07140005, 0.55419999,
    0.63090003, 0.07140005, 0.70069999,
    0.47139999, 0.07140006, 0.81660002,
    0.29139999, 0.07140007, 0.89670002,
    0.09860000, 0.07140008, 0.93769997,
    -0.09860000, 0.07140008, 0.93769997,
    -0.29139999, 0.07140007, 0.89670002,
    -0.47139999, 0.07140006, 0.81660002,
    -0.63090003, 0.07140005, 0.70069999,
    -0.76279998, 0.07140005, 0.55419999,
    -0.86140001, 0.07140003, 0.38350001,
    -0.89289999, 0.04140002, 0.18979999,
    -0.87690002, 0.01880000, -0.00000000,
    -0.85769999, 0.01879999, -0.18230000,
    -0.83389997, 0.04139997, -0.37130001,
    -0.73850000, 0.04139996, -0.53659999,
    -0.61080003, 0.04139995, -0.67839998,
    -0.45640001, 0.04139994, -0.79060000,
    -0.28209999, 0.04139993, -0.86820000,
    -0.09540000, 0.04139993, -0.90789998,
    0.09540000, 0.04139993, -0.90789998,
    0.28209999, 0.04139993, -0.86820000,
    0.45640001, 0.04139994, -0.79060000,
    0.61080003, 0.04139995, -0.67839998,
    0.73850000, 0.04139996, -0.53659999,
    0.83389997, 0.04139997, -0.37130001,
    0.89289999, 0.04139999, -0.18979999,
    0.91280001, 0.04140000, -0.00000000,
    0.89289999, 0.04140002, 0.18979999,
    0.83389997, 0.04140003, 0.37130001,
    0.73850000, 0.04140004, 0.53659999,
    0.61080003, 0.04140005, 0.67839998,
    0.45640001, 0.04140006, 0.79049999,
    0.28209999, 0.04140007, 0.86820000,
    0.09540000, 0.04140007, 0.90780002,
    -0.09540000, 0.04140007, 0.90780002,
    -0.28209999, 0.04140007, 0.86820000,
    -0.45640001, 0.04140006, 0.79049999,
    -0.61080003, 0.04140005, 0.67839998,
    -0.73850000, 0.04140004, 0.53659999,
    -0.83389997, 0.04140003, 0.37130001,
    -0.85769999, 0.01880001, 0.18230000,
    -0.83679998, 0.00480000, -0.00000000,
    -0.81849998, 0.00479999, -0.17399999,
    -0.80110002, 0.01879997, -0.35670000,
    -0.70940000, 0.01879996, -0.51539999,
    -0.58679998, 0.01879995, -0.65170002,
    -0.43840000, 0.01879994, -0.75940001,
    -0.27100000, 0.01879994, -0.83399999,
    -0.09170000, 0.01879993, -0.87210000,
    0.09170000, 0.01879993, -0.87210000,
    0.27100000, 0.01879994, -0.83399999,
    0.43840000, 0.01879994, -0.75940001,
    0.58679998, 0.01879995, -0.65170002,
    0.70940000, 0.01879996, -0.51539999,
    0.80110002, 0.01879997, -0.35670000,
    0.85769999, 0.01879999, -0.18230000,
    0.87690002, 0.01880000, -0.00000000,
    0.85769999, 0.01880001, 0.18230000,
    0.80110002, 0.01880003, 0.35670000,
    0.70940000, 0.01880004, 0.51539999,
    0.58679998, 0.01880005, 0.65170002,
    0.43840000, 0.01880006, 0.75940001,
    0.27100000, 0.01880006, 0.83399999,
    0.09170000, 0.01880006, 0.87210000,
    -0.09170000, 0.01880006, 0.87210000,
    -0.27100000, 0.01880006, 0.83399999,
    -0.43840000, 0.01880006, 0.75940001,
    -0.58679998, 0.01880005, 0.65170002,
    -0.70940000, 0.01880004, 0.51539999,
    -0.80110002, 0.01880003, 0.35670000,
    -0.81849998, 0.00480001, 0.17399999,
    -0.79460001, 0.00000000, 0.00000000,
    -0.77719998, -0.00000001, -0.16520000,
    -0.76450002, 0.00479997, -0.34040001,
    -0.67699999, 0.00479996, -0.49190000,
    -0.55989999, 0.00479995, -0.62190002,
    -0.41839999, 0.00479995, -0.72469997,
    -0.25860000, 0.00479994, -0.79589999,
    -0.08750000, 0.00479994, -0.83219999,
    0.08750000, 0.00479994, -0.83219999,
    0.25860000, 0.00479994, -0.79589999,
    0.41839999, 0.00479995, -0.72469997,
    0.55989999, 0.00479995, -0.62190002,
    0.67699999, 0.00479996, -0.49190000,
    0.76450002, 0.00479997, -0.34040001,
    0.81849998, 0.00479999, -0.17399999,
    0.83679998, 0.00480000, -0.00000000,
    0.81849998, 0.00480001, 0.17399999,
    0.76450002, 0.00480003, 0.34040001,
    0.67699999, 0.00480004, 0.49190000,
    0.55989999, 0.00480005, 0.62190002,
    0.41839999, 0.00480005, 0.72469997,
    0.25860000, 0.00480006, 0.79579997,
    0.08750000, 0.00480006, 0.83219999,
    -0.08750000, 0.00480006, 0.83219999,
    -0.25860000, 0.00480006, 0.79579997,
    -0.41839999, 0.00480005, 0.72469997,
    -0.55989999, 0.00480005, 0.62190002,
    -0.67699999, 0.00480004, 0.49190000,
    -0.76450002, 0.00480003, 0.34040001,
    -0.77719998, 0.00000001, 0.16520000,
    0.00000000, 0.00000000, 0.00000000,
    -0.72589999, -0.00000002, -0.32319999,
    -0.64289999, -0.00000004, -0.46709999,
    -0.53170002, -0.00000004, -0.59050000,
    -0.39730000, -0.00000005, -0.68820000,
    -0.24550000, -0.00000006, -0.75569999,
    -0.08310000, -0.00000006, -0.79030001,
    0.08310000, -0.00000006, -0.79030001,
    0.24550000, -0.00000006, -0.75569999,
    0.39730000, -0.00000005, -0.68820000,
    0.53170002, -0.00000004, -0.59050000,
    0.64289999, -0.00000004, -0.46709999,
    0.72589999, -0.00000002, -0.32319999,
    0.77719998, -0.00000001, -0.16520000,
    0.79460001, 0.00000000, 0.00000000,
    0.77719998, 0.00000001, 0.16520000,
    0.72589999, 0.00000002, 0.32319999,
    0.64289999, 0.00000004, 0.46709999,
    0.53170002, 0.00000004, 0.59050000,
    0.39730000, 0.00000005, 0.68809998,
    0.24550000, 0.00000006, 0.75569999,
    0.08310000, 0.00000006, 0.79030001,
    -0.08310000, 0.00000006, 0.79030001,
    -0.24550000, 0.00000006, 0.75569999,
    -0.39730000, 0.00000005, 0.68809998,
    -0.53170002, 0.00000004, 0.59050000,
    -0.64289999, 0.00000004, 0.46709999,
    -0.72589999, 0.00000002, 0.32319999,
    0.29960001, 0.35639998, -0.25060004,
    0.16990000, 0.35639998, -0.38510004,
    0.02820000, 0.35639998, -0.43550003,
    0.62379998, 0.35640004, 0.30669996,
    0.34279999, 0.35640004, 0.49159998,
    0.44130000, 0.35640004, 0.24659997,
    0.43410000, 0.35640001, 0.10969997,
    0.39080000, 0.35640001, 0.03049997,
    0.38839999, 0.35640001, -0.06560003,
    0.21310000, 0.35640001, -0.06800003,
    0.21310000, 0.35640001, -0.06800003,
    0.07860000, 0.35640001, 0.11449997,
    0.29240000, 0.35640001, 0.06889997,
    0.30919999, 0.35640001, 0.16019997,
    0.20829999, 0.35640004, 0.21059997,
    0.25870001, 0.35640004, 0.44359997,
    0.07140000, 0.35640004, 0.35229996,
    0.06900000, 0.35640004, 0.26589996,
    0.06900000, 0.35640004, 0.26589996,
    -0.02230000, 0.35640001, -0.00560003,
    -0.02230000, 0.35640001, -0.00560003,
    -0.12560000, 0.35640001, 0.06889997,
    -0.16640000, 0.35640001, -0.11120003,
    -0.34169999, 0.35640001, -0.11600003,
    -0.34169999, 0.35640001, -0.11600003,
    -0.34169999, 0.35640001, 0.01849997,
    -0.11120000, 0.35640004, 0.21299997,
    -0.02470000, 0.35640004, 0.48919997,
    -0.11600000, 0.35640004, 0.30429998,
    -0.11600000, 0.35640004, 0.30429998,
    -0.30329999, 0.35640004, 0.40039998,
    -0.25529999, 0.35640001, 0.16499998,
    -0.34650001, 0.35640001, 0.12649997,
    -0.39460000, 0.35640001, -0.02240003,
    -0.48590001, 0.35640001, 0.06409997,
    -0.49070001, 0.35640004, 0.20339997,
    -0.49070001, 0.35640004, 0.20339997,
    -0.38980001, 0.35640004, 0.44839996,
    -0.68040001, 0.35640004, 0.26109996,
    -0.68279999, 0.35640001, -0.01040003,
    -0.63480002, 0.35639998, -0.24820003,
    -0.49070001, 0.35639998, -0.44030002,
    -0.26010001, 0.35639998, -0.30340004,
    -0.12080000, 0.35639998, -0.44030002,
    0.53740001, 0.35639998, -0.39230004,
    0.67430001, 0.35639998, -0.20730004,
    0.67430001, 0.35639998, -0.20730004,
    0.67189997, 0.35640001, 0.03529998,
    -0.11120000, 0.40350002, 0.21299997,
    0.06900000, 0.40350002, 0.26589996,
    -0.02230000, 0.40349999, -0.00560003,
    -0.34169999, 0.40349999, 0.01849997,
    -0.12560000, 0.40349999, 0.06889997,
    -0.34169999, 0.40349999, -0.11600003,
    -0.34169999, 0.40349999, -0.11600003,
    -0.16640000, 0.40349999, -0.11120003,
    0.29240000, 0.40349999, 0.06889997,
    0.38839999, 0.40349999, -0.06560003,
    0.07860000, 0.40349999, 0.11449997,
    0.21310000, 0.40349999, -0.06800003,
    0.21310000, 0.40349999, -0.06800003,
  ]),
  indices: new Uint16Array([
    0, 1, 2, 0, 2, 3, 94, 95, 1, 94, 1, 0,
    1, 96, 97, 1, 97, 2, 3, 2, 98, 3, 98, 4,
    4, 98, 99, 4, 99, 5, 5, 99, 100, 5, 100, 6,
    6, 100, 101, 6, 101, 7, 7, 101, 102, 7, 102, 8,
    8, 102, 103, 8, 103, 9, 9, 103, 104, 9, 104, 10,
    10, 104, 105, 10, 105, 11, 11, 105, 106, 11, 106, 12,
    12, 106, 107, 12, 107, 13, 13, 107, 108, 13, 108, 14,
    14, 108, 109, 14, 109, 15, 15, 109, 110, 15, 110, 16,
    16, 110, 111, 16, 111, 80, 80, 111, 112, 80, 112, 81,
    81, 112, 113, 81, 113, 82, 82, 113, 114, 82, 114, 83,
    83, 114, 115, 83, 115, 84, 84, 115, 116, 84, 116, 85,
    85, 116, 117, 85, 117, 86, 86, 117, 118, 86, 118, 87,
    87, 118, 119, 87, 119, 88, 88, 119, 120, 88, 120, 89,
    89, 120, 121, 89, 121, 90, 90, 121, 122, 90, 122, 91,
    91, 122, 123, 91, 123, 92, 92, 123, 124, 92, 124, 93,
    93, 124, 95, 93, 95, 94, 95, 125, 96, 95, 96, 1,
    96, 126, 127, 96, 127, 97, 2, 97, 128, 2, 128, 98,
    98, 128, 129, 98, 129, 99, 99, 129, 130, 99, 130, 100,
    100, 130, 131, 100, 131, 101, 101, 131, 132, 101, 132, 102,
    102, 132, 133, 102, 133, 103, 103, 133, 134, 103, 134, 104,
    104, 134, 135, 104, 135, 105, 105, 135, 136, 105, 136, 106,
    106, 136, 137, 106, 137, 107, 107, 137, 138, 107, 138, 108,
    108, 138, 139, 108, 139, 109, 109, 139, 140, 109, 140, 110,
    110, 140, 141, 110, 141, 111, 111, 141, 142, 111, 142, 112,
    112, 142, 143, 112, 143, 113, 113, 143, 144, 113, 144, 114,
    114, 144, 145, 114, 145, 115, 115, 145, 146, 115, 146, 116,
    116, 146, 147, 116, 147, 117, 117, 147, 148, 117, 148, 118,
    118, 148, 149, 118, 149, 119, 119, 149, 150, 119, 150, 120,
    120, 150, 151, 120, 151, 121, 121, 151, 152, 121, 152, 122,
    122, 152, 153, 122, 153, 123, 123, 153, 154, 123, 154, 124,
    124, 154, 125, 124, 125, 95, 125, 155, 126, 125, 126, 96,
    126, 156, 157, 126, 157, 127, 97, 127, 158, 97, 158, 128,
    128, 158, 159, 128, 159, 129, 129, 159, 160, 129, 160, 130,
    130, 160, 161, 130, 161, 131, 131, 161, 162, 131, 162, 132,
    132, 162, 163, 132, 163, 133, 133, 163, 164, 133, 164, 134,
    134, 164, 165, 134, 165, 135, 135, 165, 166, 135, 166, 136,
    136, 166, 167, 136, 167, 137, 137, 167, 168, 137, 168, 138,
    138, 168, 169, 138, 169, 139, 139, 169, 170, 139, 170, 140,
    140, 170, 171, 140, 171, 141, 141, 171, 172, 141, 172, 142,
    142, 172, 173, 142, 173, 143, 143, 173, 174, 143, 174, 144,
    144, 174, 175, 144, 175, 145, 145, 175, 176, 145, 176, 146,
    146, 176, 177, 146, 177, 147, 147, 177, 178, 147, 178, 148,
    148, 178, 179, 148, 179, 149, 149, 179, 180, 149, 180, 150,
    150, 180, 181, 150, 181, 151, 151, 181, 182, 151, 182, 152,
    152, 182, 183, 152, 183, 153, 153, 183, 184, 153, 184, 154,
    154, 184, 155, 154, 155, 125, 155, 185, 156, 155, 156, 126,
    156, 186, 187, 156, 187, 157, 127, 157, 188, 127, 188, 158,
    158, 188, 189, 158, 189, 159, 159, 189, 190, 159, 190, 160,
    160, 190, 191, 160, 191, 161, 161, 191, 192, 161, 192, 162,
    162, 192, 193, 162, 193, 163, 163, 193, 194, 163, 194, 164,
    164, 194, 195, 164, 195, 165, 165, 195, 196, 165, 196, 166,
    166, 196, 197, 166, 197, 167, 167, 197, 198, 167, 198, 168,
    168, 198, 199, 168, 199, 169, 169, 199, 200, 169, 200, 170,
    170, 200, 201, 170, 201, 171, 171, 201, 202, 171, 202, 172,
    172, 202, 203, 172, 203, 173, 173, 203, 204, 173, 204, 174,
    174, 204, 205, 174, 205, 175, 175, 205, 206, 175, 206, 176,
    176, 206, 207, 176, 207, 177, 177, 207, 208, 177, 208, 178,
    178, 208, 209, 178, 209, 179, 179, 209, 210, 179, 210, 180,
    180, 210, 211, 180, 211, 181, 181, 211, 212, 181, 212, 182,
    182, 212, 213, 182, 213, 183, 183, 213, 214, 183, 214, 184,
    184, 214, 185, 184, 185, 155, 185, 215, 186, 185, 186, 156,
    186, 216, 217, 186, 217, 187, 157, 187, 218, 157, 218, 188,
    188, 218, 219, 188, 219, 189, 189, 219, 220, 189, 220, 190,
    190, 220, 221, 190, 221, 191, 191, 221, 222, 191, 222, 192,
    192, 222, 223, 192, 223, 193, 193, 223, 224, 193, 224, 194,
    194, 224, 225, 194, 225, 195, 195, 225, 226, 195, 226, 196,
    196, 226, 227, 196, 227, 197, 197, 227, 228, 197, 228, 198,
    198, 228, 229, 198, 229, 199, 199, 229, 230, 199, 230, 200,
    200, 230, 231, 200, 231, 201, 201, 231, 232, 201, 232, 202,
    202, 232, 233, 202, 233, 203, 203, 233, 234, 203, 234, 204,
    204, 234, 235, 204, 235, 205, 205, 235, 236, 205, 236, 206,
    206, 236, 237, 206, 237, 207, 207, 237, 238, 207, 238, 208,
    208, 238, 239, 208, 239, 209, 209, 239, 240, 209, 240, 210,
    210, 240, 241, 210, 241, 211, 211, 241, 242, 211, 242, 212,
    212, 242, 243, 212, 243, 213, 213, 243, 244, 213, 244, 214,
    214, 244, 215, 214, 215, 185, 215, 245, 216, 215, 216, 186,
    216, 248, 250, 216, 250, 217, 187, 217, 251, 187, 251, 218,
    218, 251, 252, 218, 252, 219, 219, 252, 253, 219, 253, 220,
    220, 253, 254, 220, 254, 221, 221, 254, 255, 221, 255, 222,
    222, 255, 256, 222, 256, 223, 223, 256, 257, 223, 257, 224,
    224, 257, 258, 224, 258, 225, 225, 258, 259, 225, 259, 226,
    226, 259, 260, 226, 260, 227, 227, 260, 261, 227, 261, 228,
    228, 261, 262, 228, 262, 229, 229, 262, 263, 229, 263, 230,
    230, 263, 264, 230, 264, 231, 231, 264, 265, 231, 265, 232,
    232, 265, 266, 232, 266, 233, 233, 266, 267, 233, 267, 234,
    234, 267, 268, 234, 268, 235, 235, 268, 269, 235, 269, 236,
    236, 269, 270, 236, 270, 237, 237, 270, 271, 237, 271, 238,
    238, 271, 272, 238, 272, 239, 239, 272, 273, 239, 273, 240,
    240, 273, 274, 240, 274, 241, 241, 274, 275, 241, 275, 242,
    242, 275, 276, 242, 276, 243, 243, 276, 277, 243, 277, 244,
    244, 277, 245, 244, 245, 215, 245, 279, 248, 245, 248, 216,
    246, 280, 282, 246, 282, 249, 217, 250, 284, 217, 284, 251,
    251, 284, 286, 251, 286, 252, 252, 286, 288, 252, 288, 253,
    253, 288, 290, 253, 290, 254, 254, 290, 292, 254, 292, 255,
    255, 292, 294, 255, 294, 256, 256, 294, 296, 256, 296, 257,
    257, 296, 298, 257, 298, 258, 258, 298, 299, 258, 299, 259,
    259, 299, 301, 259, 301, 260, 260, 301, 303, 260, 303, 261,
    261, 303, 305, 261, 305, 262, 262, 305, 307, 262, 307, 263,
    263, 307, 309, 263, 309, 264, 264, 309, 311, 264, 311, 265,
    265, 311, 313, 265, 313, 266, 266, 313, 315, 266, 315, 267,
    267, 315, 317, 267, 317, 268, 268, 317, 319, 268, 319, 269,
    269, 319, 321, 269, 321, 270, 270, 321, 323, 270, 323, 271,
    271, 323, 325, 271, 325, 272, 272, 325, 327, 272, 327, 273,
    273, 327, 329, 273, 329, 274, 274, 329, 331, 274, 331, 275,
    275, 331, 334, 275, 334, 276, 276, 334, 336, 276, 336, 277,
    277, 336, 279, 277, 279, 245, 278, 337, 281, 278, 281, 247,
    280, 338, 341, 280, 341, 282, 249, 282, 343, 249, 343, 283,
    283, 343, 344, 283, 344, 285, 285, 344, 345, 285, 345, 287,
    287, 345, 346, 287, 346, 289, 289, 346, 347, 289, 347, 291,
    291, 347, 348, 291, 348, 293, 293, 348, 349, 293, 349, 295,
    295, 349, 350, 295, 350, 297, 297, 350, 351, 297, 351, 300,
    300, 351, 352, 300, 352, 302, 302, 352, 353, 302, 353, 304,
    304, 353, 354, 304, 354, 306, 306, 354, 355, 306, 355, 308,
    308, 355, 356, 308, 356, 310, 310, 356, 357, 310, 357, 312,
    312, 357, 358, 312, 358, 314, 314, 358, 359, 314, 359, 316,
    316, 359, 360, 316, 360, 318, 318, 360, 361, 318, 361, 320,
    320, 361, 362, 320, 362, 322, 322, 362, 363, 322, 363, 324,
    324, 363, 364, 324, 364, 326, 326, 364, 365, 326, 365, 328,
    328, 365, 366, 328, 366, 330, 330, 366, 367, 330, 367, 332,
    332, 367, 368, 332, 368, 333, 333, 368, 369, 333, 369, 335,
    335, 369, 337, 335, 337, 278, 337, 370, 340, 337, 340, 281,
    339, 372, 373, 339, 373, 342, 282, 341, 374, 282, 374, 343,
    343, 374, 376, 343, 376, 344, 344, 376, 378, 344, 378, 345,
    345, 378, 380, 345, 380, 346, 346, 380, 382, 346, 382, 347,
    347, 382, 384, 347, 384, 348, 348, 384, 386, 348, 386, 349,
    349, 386, 388, 349, 388, 350, 350, 388, 391, 350, 391, 351,
    351, 391, 393, 351, 393, 352, 352, 393, 395, 352, 395, 353,
    353, 395, 397, 353, 397, 354, 354, 397, 399, 354, 399, 355,
    355, 399, 401, 355, 401, 356, 356, 401, 403, 356, 403, 357,
    357, 403, 405, 357, 405, 358, 358, 405, 407, 358, 407, 359,
    359, 407, 409, 359, 409, 360, 360, 409, 411, 360, 411, 361,
    361, 411, 413, 361, 413, 362, 362, 413, 415, 362, 415, 363,
    363, 415, 417, 363, 417, 364, 364, 417, 419, 364, 419, 365,
    365, 419, 421, 365, 421, 366, 366, 421, 423, 366, 423, 367,
    367, 423, 424, 367, 424, 368, 368, 424, 426, 368, 426, 369,
    369, 426, 370, 369, 370, 337, 371, 428, 372, 371, 372, 339,
    372, 429, 430, 372, 430, 373, 342, 373, 431, 342, 431, 375,
    375, 431, 432, 375, 432, 377, 377, 432, 433, 377, 433, 379,
    379, 433, 434, 379, 434, 381, 381, 434, 435, 381, 435, 383,
    383, 435, 436, 383, 436, 385, 385, 436, 437, 385, 437, 387,
    387, 437, 438, 387, 438, 389, 389, 438, 439, 389, 439, 390,
    390, 439, 440, 390, 440, 392, 392, 440, 441, 392, 441, 394,
    394, 441, 442, 394, 442, 396, 396, 442, 443, 396, 443, 398,
    398, 443, 444, 398, 444, 400, 400, 444, 445, 400, 445, 402,
    402, 445, 446, 402, 446, 404, 404, 446, 447, 404, 447, 406,
    406, 447, 448, 406, 448, 408, 408, 448, 449, 408, 449, 410,
    410, 449, 450, 410, 450, 412, 412, 450, 451, 412, 451, 414,
    414, 451, 452, 414, 452, 416, 416, 452, 453, 416, 453, 418,
    418, 453, 454, 418, 454, 420, 420, 454, 455, 420, 455, 422,
    422, 455, 456, 422, 456, 425, 425, 456, 457, 425, 457, 427,
    427, 457, 428, 427, 428, 371, 428, 458, 429, 428, 429, 372,
    429, 459, 460, 429, 460, 430, 373, 430, 461, 373, 461, 431,
    431, 461, 462, 431, 462, 432, 432, 462, 463, 432, 463, 433,
    433, 463, 464, 433, 464, 434, 434, 464, 465, 434, 465, 435,
    435, 465, 466, 435, 466, 436, 436, 466, 467, 436, 467, 437,
    437, 467, 468, 437, 468, 438, 438, 468, 469, 438, 469, 439,
    439, 469, 470, 439, 470, 440, 440, 470, 471, 440, 471, 441,
    441, 471, 472, 441, 472, 442, 442, 472, 473, 442, 473, 443,
    443, 473, 474, 443, 474, 444, 444, 474, 475, 444, 475, 445,
    445, 475, 476, 445, 476, 446, 446, 476, 477, 446, 477, 447,
    447, 477, 478, 447, 478, 448, 448, 478, 479, 448, 479, 449,
    449, 479, 480, 449, 480, 450, 450, 480, 481, 450, 481, 451,
    451, 481, 482, 451, 482, 452, 452, 482, 483, 452, 483, 453,
    453, 483, 484, 453, 484, 454, 454, 484, 485, 454, 485, 455,
    455, 485, 486, 455, 486, 456, 456, 486, 487, 456, 487, 457,
    457, 487, 458, 457, 458, 428, 458, 488, 459, 458, 459, 429,
    459, 489, 490, 459, 490, 460, 430, 460, 491, 430, 491, 461,
    461, 491, 492, 461, 492, 462, 462, 492, 493, 462, 493, 463,
    463, 493, 494, 463, 494, 464, 464, 494, 495, 464, 495, 465,
    465, 495, 496, 465, 496, 466, 466, 496, 497, 466, 497, 467,
    467, 497, 498, 467, 498, 468, 468, 498, 499, 468, 499, 469,
    469, 499, 500, 469, 500, 470, 470, 500, 501, 470, 501, 471,
    471, 501, 502, 471, 502, 472, 472, 502, 503, 472, 503, 473,
    473, 503, 504, 473, 504, 474, 474, 504, 505, 474, 505, 475,
    475, 505, 506, 475, 506, 476, 476, 506, 507, 476, 507, 477,
    477, 507, 508, 477, 508, 478, 478, 508, 509, 478, 509, 479,
    479, 509, 510, 479, 510, 480, 480, 510, 511, 480, 511, 481,
    481, 511, 512, 481, 512, 482, 482, 512, 513, 482, 513, 483,
    483, 513, 514, 483, 514, 484, 484, 514, 515, 484, 515, 485,
    485, 515, 516, 485, 516, 486, 486, 516, 517, 486, 517, 487,
    487, 517, 488, 487, 488, 458, 488, 518, 489, 488, 489, 459,
    489, 519, 520, 489, 520, 490, 460, 490, 521, 460, 521, 491,
    491, 521, 522, 491, 522, 492, 492, 522, 523, 492, 523, 493,
    493, 523, 524, 493, 524, 494, 494, 524, 525, 494, 525, 495,
    495, 525, 526, 495, 526, 496, 496, 526, 527, 496, 527, 497,
    497, 527, 528, 497, 528, 498, 498, 528, 529, 498, 529, 499,
    499, 529, 530, 499, 530, 500, 500, 530, 531, 500, 531, 501,
    501, 531, 532, 501, 532, 502, 502, 532, 533, 502, 533, 503,
    503, 533, 534, 503, 534, 504, 504, 534, 535, 504, 535, 505,
    505, 535, 536, 505, 536, 506, 506, 536, 537, 506, 537, 507,
    507, 537, 538, 507, 538, 508, 508, 538, 539, 508, 539, 509,
    509, 539, 540, 509, 540, 510, 510, 540, 541, 510, 541, 511,
    511, 541, 542, 511, 542, 512, 512, 542, 543, 512, 543, 513,
    513, 543, 544, 513, 544, 514, 514, 544, 545, 514, 545, 515,
    515, 545, 546, 515, 546, 516, 516, 546, 547, 516, 547, 517,
    517, 547, 518, 517, 518, 488, 518, 548, 519, 518, 519, 489,
    519, 549, 550, 519, 550, 520, 490, 520, 551, 490, 551, 521,
    521, 551, 552, 521, 552, 522, 522, 552, 553, 522, 553, 523,
    523, 553, 554, 523, 554, 524, 524, 554, 555, 524, 555, 525,
    525, 555, 556, 525, 556, 526, 526, 556, 557, 526, 557, 527,
    527, 557, 558, 527, 558, 528, 528, 558, 559, 528, 559, 529,
    529, 559, 560, 529, 560, 530, 530, 560, 561, 530, 561, 531,
    531, 561, 562, 531, 562, 532, 532, 562, 563, 532, 563, 533,
    533, 563, 564, 533, 564, 534, 534, 564, 565, 534, 565, 535,
    535, 565, 566, 535, 566, 536, 536, 566, 567, 536, 567, 537,
    537, 567, 568, 537, 568, 538, 538, 568, 569, 538, 569, 539,
    539, 569, 570, 539, 570, 540, 540, 570, 571, 540, 571, 541,
    541, 571, 572, 541, 572, 542, 542, 572, 573, 542, 573, 543,
    543, 573, 574, 543, 574, 544, 544, 574, 575, 544, 575, 545,
    545, 575, 576, 545, 576, 546, 546, 576, 577, 546, 577, 547,
    547, 577, 548, 547, 548, 518, 548, 578, 549, 548, 549, 519,
    549, 579, 580, 549, 580, 550, 520, 550, 581, 520, 581, 551,
    551, 581, 582, 551, 582, 552, 552, 582, 583, 552, 583, 553,
    553, 583, 584, 553, 584, 554, 554, 584, 585, 554, 585, 555,
    555, 585, 586, 555, 586, 556, 556, 586, 587, 556, 587, 557,
    557, 587, 588, 557, 588, 558, 558, 588, 589, 558, 589, 559,
    559, 589, 590, 559, 590, 560, 560, 590, 591, 560, 591, 561,
    561, 591, 592, 561, 592, 562, 562, 592, 593, 562, 593, 563,
    563, 593, 594, 563, 594, 564, 564, 594, 595, 564, 595, 565,
    565, 595, 596, 565, 596, 566, 566, 596, 597, 566, 597, 567,
    567, 597, 598, 567, 598, 568, 568, 598, 599, 568, 599, 569,
    569, 599, 600, 569, 600, 570, 570, 600, 601, 570, 601, 571,
    571, 601, 602, 571, 602, 572, 572, 602, 603, 572, 603, 573,
    573, 603, 604, 573, 604, 574, 574, 604, 605, 574, 605, 575,
    575, 605, 606, 575, 606, 576, 576, 606, 607, 576, 607, 577,
    577, 607, 578, 577, 578, 548, 578, 608, 579, 578, 579, 549,
    579, 609, 580, 550, 580, 610, 550, 610, 581, 581, 610, 611,
    581, 611, 582, 582, 611, 612, 582, 612, 583, 583, 612, 613,
    583, 613, 584, 584, 613, 614, 584, 614, 585, 585, 614, 615,
    585, 615, 586, 586, 615, 616, 586, 616, 587, 587, 616, 617,
    587, 617, 588, 588, 617, 618, 588, 618, 589, 589, 618, 619,
    589, 619, 590, 590, 619, 620, 590, 620, 591, 591, 620, 621,
    591, 621, 592, 592, 621, 622, 592, 622, 593, 593, 622, 623,
    593, 623, 594, 594, 623, 624, 594, 624, 595, 595, 624, 625,
    595, 625, 596, 596, 625, 626, 596, 626, 597, 597, 626, 627,
    597, 627, 598, 598, 627, 628, 598, 628, 599, 599, 628, 629,
    599, 629, 600, 600, 629, 630, 600, 630, 601, 601, 630, 631,
    601, 631, 602, 602, 631, 632, 602, 632, 603, 603, 632, 633,
    603, 633, 604, 604, 633, 634, 604, 634, 605, 605, 634, 635,
    605, 635, 606, 606, 635, 636, 606, 636, 607, 607, 636, 608,
    607, 608, 578, 608, 609, 579, 580, 609, 610, 610, 609, 611,
    611, 609, 612, 612, 609, 613, 613, 609, 614, 614, 609, 615,
    615, 609, 616, 616, 609, 617, 617, 609, 618, 618, 609, 619,
    619, 609, 620, 620, 609, 621, 621, 609, 622, 622, 609, 623,
    623, 609, 624, 624, 609, 625, 625, 609, 626, 626, 609, 627,
    627, 609, 628, 628, 609, 629, 629, 609, 630, 630, 609, 631,
    631, 609, 632, 632, 609, 633, 633, 609, 634, 634, 609, 635,
    635, 609, 636, 636, 609, 608, 23, 22, 637, 23, 637, 638,
    26, 23, 638, 26, 638, 639, 29, 31, 33, 11, 27, 29,
    9, 10, 11, 7, 8, 9, 5, 6, 7, 3, 4, 5,
    94, 0, 3, 92, 93, 94, 90, 91, 92, 88, 89, 90,
    86, 87, 88, 84, 85, 86, 82, 83, 84, 80, 81, 82,
    18, 16, 80, 79, 18, 80, 80, 82, 84, 84, 86, 88,
    88, 90, 92, 92, 94, 3, 3, 5, 7, 7, 9, 11,
    11, 29, 33, 7, 11, 33, 84, 88, 92, 77, 79, 80,
    71, 73, 75, 77, 80, 84, 68, 71, 75, 75, 77, 84,
    3, 7, 33, 3, 33, 35, 67, 68, 75, 63, 65, 67,
    59, 60, 63, 54, 56, 59, 50, 52, 54, 46, 48, 50,
    40, 44, 46, 40, 46, 50, 40, 50, 54, 40, 54, 59,
    63, 67, 75, 59, 63, 75, 3, 35, 37, 3, 37, 39,
    59, 75, 84, 40, 59, 84, 92, 3, 39, 40, 84, 92,
    39, 40, 92, 22, 19, 681, 22, 681, 637, 28, 26, 639,
    28, 639, 680, 76, 74, 641, 76, 641, 640, 78, 76, 640,
    78, 640, 684, 17, 78, 684, 17, 684, 682, 19, 17, 683,
    19, 683, 681, 30, 28, 680, 30, 680, 679, 32, 30, 679,
    32, 679, 678, 34, 32, 678, 34, 678, 677, 36, 34, 677,
    36, 677, 676, 38, 36, 676, 38, 676, 675, 41, 38, 675,
    41, 675, 674, 42, 41, 674, 42, 674, 672, 45, 43, 673,
    45, 673, 671, 47, 45, 671, 47, 671, 670, 49, 47, 670,
    49, 670, 669, 51, 49, 669, 51, 669, 668, 53, 51, 668,
    53, 668, 667, 57, 53, 667, 57, 667, 666, 58, 55, 665,
    58, 665, 664, 61, 58, 664, 61, 664, 653, 685, 686, 655,
    685, 655, 663, 687, 685, 663, 687, 663, 657, 688, 689, 658,
    688, 658, 662, 691, 688, 662, 691, 662, 661, 692, 690, 660,
    692, 660, 659, 689, 692, 659, 689, 659, 658, 686, 687, 656,
    686, 656, 654, 62, 61, 653, 62, 653, 652, 64, 62, 652,
    64, 652, 651, 66, 64, 651, 66, 651, 650, 69, 66, 650,
    69, 650, 644, 693, 694, 645, 693, 645, 649, 695, 693, 649,
    695, 649, 648, 696, 695, 648, 696, 648, 646, 694, 697, 647,
    694, 647, 645, 70, 69, 644, 70, 644, 643, 72, 70, 643,
    72, 643, 642, 74, 72, 642, 74, 642, 641, 20, 21, 24,
    24, 25, 11, 11, 12, 13, 13, 14, 15, 15, 16, 18,
    20, 24, 11, 15, 18, 20, 11, 13, 15, 11, 15, 20,
  ]),
  normals: new Float32Array([
    -0.05980062, 0.99821034, 0.00000000,
    -0.22980847, 0.97323587, 0.00000000,
    -0.22471200, 0.97325199, -0.04780255,
    -0.05850061, 0.99821036, -0.01240013,
    -0.05460068, 0.99821253, -0.02430030,
    -0.04840054, 0.99821108, -0.03510039,
    -0.04000051, 0.99821268, -0.04440056,
    -0.02990029, 0.99820974, -0.05180051,
    -0.01850016, 0.99820844, -0.05690048,
    -0.00630005, 0.99820839, -0.05950050,
    0.00630005, 0.99820839, -0.05950050,
    0.01850016, 0.99820844, -0.05690048,
    0.02990029, 0.99820974, -0.05180051,
    0.04000051, 0.99821268, -0.04440056,
    0.04840054, 0.99821108, -0.03510039,
    0.05460068, 0.99821253, -0.02430030,
    0.07219793, 0.99727143, -0.01539956,
    -0.47330998, 0.86741825, 0.15350324,
    -0.47330998, 0.86741825, 0.15350324,
    -0.15990362, -0.58281315, 0.79671806,
    -0.15990362, -0.58281315, 0.79671806,
    -0.10699887, 0.59039373, 0.79999156,
    -0.10709772, 0.59038742, 0.79998298,
    -0.40757942, -0.65906673, 0.63206809,
    -0.40760627, -0.65901016, 0.63210975,
    -0.13730597, -0.67402937, 0.72583158,
    -0.13739411, -0.67397117, 0.72586894,
    -0.13740410, -0.67402011, 0.72582161,
    0.28290236, -0.62830525, 0.72470599,
    0.28290236, -0.62830525, 0.72470599,
    0.09679656, 0.59217894, 0.79997158,
    0.09679656, 0.59217894, 0.79997158,
    0.15800186, -0.58320681, 0.79680940,
    0.15800186, -0.58320681, 0.79680940,
    0.68500050, -0.66070052, 0.30700023,
    0.68500050, -0.66070052, 0.30700023,
    0.72580307, -0.68440293, 0.06930030,
    0.72570608, -0.68450574, 0.06930058,
    0.69119734, -0.61419762, -0.38079852,
    0.69119734, -0.61419762, -0.38079852,
    -0.53738394, -0.54298374, -0.64528069,
    -0.53741311, -0.54291325, -0.64531570,
    -0.73711313, 0.66261174, 0.13270235,
    -0.73715878, 0.66256292, 0.13269257,
    -0.73715878, 0.66256292, 0.13269257,
    -0.70737065, 0.63087382, -0.31878675,
    -0.70739317, 0.63089395, -0.31869692,
    0.20539437, 0.55748474, -0.80437797,
    0.20539437, 0.55748474, -0.80437797,
    0.57578245, -0.62418100, -0.52808395,
    0.57578245, -0.62418100, -0.52808395,
    0.71512221, 0.58841829, -0.37731173,
    0.71512221, 0.58841829, -0.37731173,
    0.50499593, -0.54999559, -0.66519468,
    0.50499593, -0.54999559, -0.66519468,
    0.25641039, 0.57662338, -0.77573139,
    0.25641039, 0.57662338, -0.77573139,
    0.25639559, 0.57669010, -0.77568669,
    0.06359899, -0.55549107, -0.82908675,
    0.06359899, -0.55549107, -0.82908675,
    -0.20250409, 0.58611179, -0.78451581,
    -0.20259998, 0.58609994, -0.78449991,
    -0.51550573, -0.55020606, -0.65690725,
    -0.51550573, -0.55020606, -0.65690725,
    -0.72699257, 0.59169395, -0.34839643,
    -0.72699257, 0.59169395, -0.34839643,
    -0.50958340, -0.65127877, -0.56228171,
    -0.50958340, -0.65127877, -0.56228171,
    0.02610016, 0.55520332, -0.83130503,
    0.02600022, 0.55520478, -0.83130719,
    0.72240610, 0.66050554, -0.20460172,
    0.72240610, 0.66050554, -0.20460172,
    0.73970013, 0.66160011, 0.12300003,
    0.73970013, 0.66160011, 0.12300003,
    0.53160823, -0.54290844, -0.65011008,
    0.53157938, -0.54297895, -0.65007479,
    -0.65009126, -0.62799158, -0.42779426,
    -0.65009126, -0.62799158, -0.42779426,
    -0.72167802, -0.68897903, -0.06699796,
    -0.72167802, -0.68897903, -0.06699796,
    0.05980062, 0.99821034, 0.00000000,
    0.05850061, 0.99821036, 0.01240013,
    0.05460068, 0.99821253, 0.02430030,
    0.04840054, 0.99821108, 0.03510039,
    0.04000051, 0.99821268, 0.04440056,
    0.02990029, 0.99820974, 0.05180051,
    0.01850016, 0.99820844, 0.05690048,
    0.00630005, 0.99820839, 0.05950050,
    -0.00630005, 0.99820839, 0.05950050,
    -0.01850016, 0.99820844, 0.05690048,
    -0.02990029, 0.99820974, 0.05180051,
    -0.04000051, 0.99821268, 0.04440056,
    -0.04840054, 0.99821108, 0.03510039,
    -0.05460068, 0.99821253, 0.02430030,
    -0.05850061, 0.99821036, 0.01240013,
    -0.22471200, 0.97325199, 0.04780255,
    -0.43979830, 0.89809657, 0.00000000,
    -0.43019793, 0.89809568, -0.09139956,
    -0.20969890, 0.97329487, -0.09339951,
    -0.18590659, 0.97323452, -0.13510480,
    -0.15350420, 0.97332658, -0.17050465,
    -0.11470283, 0.97332401, -0.19870490,
    -0.07100194, 0.97322667, -0.21860598,
    -0.02400098, 0.97333966, -0.22810930,
    0.02400098, 0.97333966, -0.22810930,
    0.07100194, 0.97322667, -0.21860598,
    0.11469394, 0.97334861, -0.19858950,
    0.15350420, 0.97332658, -0.17050465,
    0.18590659, 0.97323452, -0.13510480,
    0.20950767, 0.97333567, -0.09340342,
    0.22471200, 0.97325199, -0.04780255,
    0.22980847, 0.97323587, 0.00000000,
    0.22471200, 0.97325199, 0.04780255,
    0.20969890, 0.97329487, 0.09339951,
    0.18590659, 0.97323452, 0.13510480,
    0.15369423, 0.97326347, 0.17069359,
    0.11480380, 0.97333217, 0.19860657,
    0.07099814, 0.97327447, 0.21839428,
    0.02399864, 0.97334492, 0.22808710,
    -0.02399864, 0.97334492, 0.22808710,
    -0.07099814, 0.97327447, 0.21839428,
    -0.11480380, 0.97333217, 0.19860657,
    -0.15369423, 0.97326347, 0.17069359,
    -0.18590659, 0.97323452, 0.13510480,
    -0.20950767, 0.97333567, 0.09340342,
    -0.43019793, 0.89809568, 0.09139956,
    -0.62761756, 0.77852180, 0.00000000,
    -0.61391052, 0.77851335, -0.13050224,
    -0.40179357, 0.89808560, -0.17889713,
    -0.35598830, 0.89797051, -0.25869151,
    -0.29420948, 0.89812898, -0.32681054,
    -0.22000385, 0.89801571, -0.38100668,
    -0.13590467, 0.89803082, -0.41841435,
    -0.04599958, 0.89809176, -0.43739597,
    0.04600148, 0.89822890, -0.43711407,
    0.13590467, 0.89803082, -0.41841435,
    0.22000385, 0.89801571, -0.38100668,
    0.29420948, 0.89812898, -0.32681054,
    0.35580008, 0.89810023, -0.25850006,
    0.40179357, 0.89808560, -0.17889713,
    0.43019793, 0.89809568, -0.09139956,
    0.43979830, 0.89809657, 0.00000000,
    0.43019793, 0.89809568, 0.09139956,
    0.40179357, 0.89808560, 0.17889713,
    0.35598830, 0.89797051, 0.25869151,
    0.29429121, 0.89807319, 0.32689024,
    0.21989731, 0.89808903, 0.38089534,
    0.13590383, 0.89812531, 0.41821177,
    0.04599958, 0.89809176, 0.43739597,
    -0.04599958, 0.89809176, 0.43739597,
    -0.13590383, 0.89812531, 0.41821177,
    -0.21989731, 0.89808903, 0.38089534,
    -0.29429121, 0.89807319, 0.32689024,
    -0.35580008, 0.89810023, 0.25850006,
    -0.40179357, 0.89808560, 0.17889713,
    -0.61391052, 0.77851335, 0.13050224,
    -0.78477526, 0.61978044, 0.00000000,
    -0.76738911, 0.62009120, -0.16309769,
    -0.57343668, 0.77844972, -0.25531629,
    -0.50798741, 0.77828063, -0.36909084,
    -0.42017314, 0.77825028, -0.46667016,
    -0.31398975, 0.77827458, -0.54378223,
    -0.19409639, 0.77818545, -0.59728888,
    -0.06560022, 0.77810270, -0.62470216,
    0.06560022, 0.77810270, -0.62470216,
    0.19409639, 0.77818545, -0.59728888,
    0.31398975, 0.77827458, -0.54378223,
    0.42017314, 0.77825028, -0.46667016,
    0.50798741, 0.77828063, -0.36909084,
    0.57343668, 0.77844972, -0.25531629,
    0.61391052, 0.77851335, -0.13050224,
    0.62761756, 0.77852180, 0.00000000,
    0.61391052, 0.77851335, 0.13050224,
    0.57343668, 0.77844972, 0.25531629,
    0.50798741, 0.77828063, 0.36909084,
    0.42009080, 0.77828296, 0.46668977,
    0.31389223, 0.77838077, 0.54368654,
    0.19399664, 0.77828648, 0.59718964,
    0.06550375, 0.77824445, 0.62453569,
    -0.06550375, 0.77824445, 0.62453569,
    -0.19399664, 0.77828648, 0.59718964,
    -0.31389223, 0.77838077, 0.54368654,
    -0.42009080, 0.77828296, 0.46668977,
    -0.50798741, 0.77828063, 0.36909084,
    -0.57343668, 0.77844972, 0.25531629,
    -0.76738911, 0.62009120, 0.16309769,
    -0.90236087, 0.43098128, 0.00000000,
    -0.88288393, 0.43049215, -0.18759658,
    -0.71683475, 0.61993005, -0.31911547,
    -0.63481510, 0.61991472, -0.46121094,
    -0.52517318, 0.61966842, -0.58327025,
    -0.39229617, 0.61999393, -0.67949337,
    -0.24250947, 0.61982417, -0.74632912,
    -0.08190100, 0.62000751, -0.78030950,
    0.08199901, 0.61989253, -0.78039055,
    0.24250947, 0.61982417, -0.74632912,
    0.39229384, 0.61989022, -0.67958933,
    0.52517318, 0.61966842, -0.58327025,
    0.63481510, 0.61991472, -0.46121094,
    0.71683475, 0.61993005, -0.31911547,
    0.76738911, 0.62009120, -0.16309769,
    0.78477526, 0.61978044, 0.00000000,
    0.76738911, 0.62009120, 0.16309769,
    0.71683475, 0.61993005, 0.31911547,
    0.63481510, 0.61991472, 0.46121094,
    0.52512562, 0.62003028, 0.58292841,
    0.39229617, 0.61999393, 0.67949337,
    0.24258547, 0.61976287, 0.74635532,
    0.08210096, 0.62010733, 0.78020916,
    -0.08210096, 0.62010733, 0.78020916,
    -0.24258547, 0.61976287, 0.74635532,
    -0.39229617, 0.61999393, 0.67949337,
    -0.52509887, 0.61979868, 0.58319874,
    -0.63481510, 0.61991472, 0.46121094,
    -0.71683475, 0.61993005, 0.31911547,
    -0.88268771, 0.43089400, 0.18759738,
    -0.97529663, 0.22089924, 0.00000000,
    -0.95400508, 0.22060116, -0.20300107,
    -0.82437009, 0.43088436, -0.36708668,
    -0.73021001, 0.43040592, -0.53060728,
    -0.60376194, 0.43107287, -0.67055776,
    -0.45111705, 0.43111632, -0.78142954,
    -0.27880033, 0.43100049, -0.85820100,
    -0.09430093, 0.43100424, -0.89740887,
    0.09429620, 0.43068263, -0.89756376,
    0.27880033, 0.43100049, -0.85820100,
    0.45129943, 0.43079946, -0.78149898,
    0.60378798, 0.43099142, -0.67058666,
    0.73007632, 0.43078602, -0.53048277,
    0.82437009, 0.43088436, -0.36708668,
    0.88288393, 0.43049215, -0.18759658,
    0.90230338, 0.43110161, 0.00000000,
    0.88262757, 0.43101348, 0.18760586,
    0.82433277, 0.43101713, 0.36701461,
    0.73021001, 0.43040592, 0.53060728,
    0.60376194, 0.43107287, 0.67055776,
    0.45111705, 0.43111632, 0.78142954,
    0.27880033, 0.43100049, 0.85820100,
    0.09430093, 0.43100424, 0.89740887,
    -0.09429620, 0.43068263, 0.89756376,
    -0.27869606, 0.43109396, 0.85818792,
    -0.45111705, 0.43111632, 0.78142954,
    -0.60380243, 0.43110176, 0.67050271,
    -0.73007632, 0.43078602, 0.53048277,
    -0.82433277, 0.43101713, 0.36701461,
    -0.95404379, 0.22061011, 0.20280932,
    -0.99844184, 0.05580234, 0.00000000,
    -0.99844184, 0.05580234, 0.00000000,
    -0.99844184, 0.05580234, 0.00000000,
    -0.97662549, 0.05570145, -0.20760542,
    -0.97662549, 0.05570145, -0.20760542,
    -0.89097426, 0.22109362, -0.39658855,
    -0.78902109, 0.22080592, -0.57331533,
    -0.65260832, 0.22080282, -0.72480928,
    -0.48759211, 0.22119642, -0.84458633,
    -0.30139453, 0.22079598, -0.92758314,
    -0.10189677, 0.22129300, -0.96986930,
    0.10189677, 0.22129300, -0.96986930,
    0.30139453, 0.22079598, -0.92758314,
    0.48759211, 0.22119642, -0.84458633,
    0.65250764, 0.22110260, -0.72480854,
    0.78902109, 0.22080592, -0.57331533,
    0.89097426, 0.22109362, -0.39658855,
    0.95400508, 0.22060116, -0.20300107,
    0.97529663, 0.22089924, 0.00000000,
    0.95404379, 0.22061011, 0.20280932,
    0.89097426, 0.22109362, 0.39658855,
    0.78902109, 0.22080592, 0.57331533,
    0.65260832, 0.22080282, 0.72480928,
    0.48760288, 0.22110131, 0.84460502,
    0.30138787, 0.22089110, 0.92756265,
    0.10189903, 0.22119788, 0.96989076,
    -0.10189677, 0.22129300, 0.96986930,
    -0.30140915, 0.22100672, 0.92752820,
    -0.48779650, 0.22109842, 0.84449397,
    -0.65238854, 0.22119611, 0.72488722,
    -0.78902109, 0.22080592, 0.57331533,
    -0.89097426, 0.22109362, 0.39658855,
    -0.97662004, 0.05580114, 0.20760425,
    -0.97662004, 0.05580114, 0.20760425,
    -1.00000000, 0.00000000, 0.00000000,
    -1.00000000, 0.00000000, 0.00000000,
    -0.97814792, 0.00000000, -0.20791019,
    -0.91216314, 0.05599774, -0.40598357,
    -0.91216314, 0.05599774, -0.40598357,
    -0.80775714, 0.05579704, -0.58686889,
    -0.80775714, 0.05579704, -0.58686889,
    -0.66813405, 0.05590285, -0.74193784,
    -0.66813405, 0.05590285, -0.74193784,
    -0.49938821, 0.05579868, -0.86457962,
    -0.49938821, 0.05579868, -0.86457962,
    -0.30861232, 0.05600223, -0.94953788,
    -0.30861232, 0.05600223, -0.94953788,
    -0.10439501, 0.05609732, -0.99295255,
    -0.10439501, 0.05609732, -0.99295255,
    0.10439501, 0.05609732, -0.99295255,
    0.10439501, 0.05609732, -0.99295255,
    0.30861232, 0.05600223, -0.94953788,
    0.30861232, 0.05600223, -0.94953788,
    0.49938821, 0.05579868, -0.86457962,
    0.49938821, 0.05579868, -0.86457962,
    0.66813405, 0.05590285, -0.74193784,
    0.66813405, 0.05590285, -0.74193784,
    0.80780907, 0.05570062, -0.58680656,
    0.80780907, 0.05570062, -0.58680656,
    0.91216314, 0.05599774, -0.40598357,
    0.91216314, 0.05599774, -0.40598357,
    0.97662549, 0.05570145, -0.20760542,
    0.97662549, 0.05570145, -0.20760542,
    0.99844184, 0.05580234, 0.00000000,
    0.99844184, 0.05580234, 0.00000000,
    0.97662004, 0.05580114, 0.20760425,
    0.97662004, 0.05580114, 0.20760425,
    0.91205048, 0.05569697, 0.40627795,
    0.91205048, 0.05569697, 0.40627795,
    0.80775714, 0.05579704, 0.58686889,
    0.80775714, 0.05579704, 0.58686889,
    0.66813405, 0.05590285, 0.74193784,
    0.66813405, 0.05590285, 0.74193784,
    0.49931595, 0.05570178, 0.86462760,
    0.49931595, 0.05570178, 0.86462760,
    0.30849597, 0.05579927, 0.94958764,
    0.30849597, 0.05579927, 0.94958764,
    0.10439560, 0.05599764, 0.99295812,
    0.10439560, 0.05599764, 0.99295812,
    -0.10439501, 0.05609732, 0.99295255,
    -0.10439501, 0.05609732, 0.99295255,
    -0.30861403, 0.05590254, 0.94954320,
    -0.30861403, 0.05590254, 0.94954320,
    -0.49932150, 0.05550239, 0.86463722,
    -0.49932150, 0.05550239, 0.86463722,
    -0.66819688, 0.05569974, 0.74189653,
    -0.66819688, 0.05569974, 0.74189653,
    -0.80780907, 0.05570062, 0.58680656,
    -0.80780907, 0.05570062, 0.58680656,
    -0.91215802, 0.05609742, 0.40598131,
    -0.91215802, 0.05609742, 0.40598131,
    -0.97814792, 0.00000000, 0.20791019,
    -0.99844184, -0.05580234, 0.00000000,
    -0.99844184, -0.05580234, 0.00000000,
    -0.99844184, -0.05580234, 0.00000000,
    -0.97662549, -0.05570145, -0.20760542,
    -0.97662549, -0.05570145, -0.20760542,
    -0.91360525, 0.00000000, -0.40660231,
    -0.80895657, 0.00000000, -0.58786841,
    -0.66913599, 0.00000000, -0.74313998,
    -0.50012935, 0.00000000, -0.86595071,
    -0.30910870, 0.00000000, -0.95102672,
    -0.10460149, 0.00000000, -0.99451422,
    0.10460149, 0.00000000, -0.99451422,
    0.30910870, 0.00000000, -0.95102672,
    0.50012935, 0.00000000, -0.86595071,
    0.66913599, 0.00000000, -0.74313998,
    0.80895657, 0.00000000, -0.58786841,
    0.91360525, 0.00000000, -0.40660231,
    0.97814792, 0.00000000, -0.20791019,
    1.00000000, 0.00000000, 0.00000000,
    0.97814792, 0.00000000, 0.20791019,
    0.91360525, 0.00000000, 0.40660231,
    0.80895657, 0.00000000, 0.58786841,
    0.66913599, 0.00000000, 0.74313998,
    0.50001101, 0.00000000, 0.86601905,
    0.30910870, 0.00000000, 0.95102672,
    0.10460149, 0.00000000, 0.99451422,
    -0.10460149, 0.00000000, 0.99451422,
    -0.30910870, 0.00000000, 0.95102672,
    -0.50012935, 0.00000000, 0.86595071,
    -0.66913599, 0.00000000, 0.74313998,
    -0.80895657, 0.00000000, 0.58786841,
    -0.91360525, 0.00000000, 0.40660231,
    -0.97662004, -0.05580114, 0.20760425,
    -0.97662004, -0.05580114, 0.20760425,
    -0.97527509, -0.22099435, 0.00000000,
    -0.95393118, -0.22100722, -0.20290665,
    -0.91216314, -0.05599774, -0.40598357,
    -0.91216314, -0.05599774, -0.40598357,
    -0.80780907, -0.05570062, -0.58680656,
    -0.80780907, -0.05570062, -0.58680656,
    -0.66813405, -0.05590285, -0.74193784,
    -0.66813405, -0.05590285, -0.74193784,
    -0.49938821, -0.05579868, -0.86457962,
    -0.49938821, -0.05579868, -0.86457962,
    -0.30861232, -0.05600223, -0.94953788,
    -0.30861232, -0.05600223, -0.94953788,
    -0.10439501, -0.05609732, -0.99295255,
    -0.10439501, -0.05609732, -0.99295255,
    0.10439501, -0.05609732, -0.99295255,
    0.10439501, -0.05609732, -0.99295255,
    0.30861232, -0.05600223, -0.94953788,
    0.30861232, -0.05600223, -0.94953788,
    0.49938821, -0.05579868, -0.86457962,
    0.49938821, -0.05579868, -0.86457962,
    0.66813405, -0.05590285, -0.74193784,
    0.66813405, -0.05590285, -0.74193784,
    0.80780907, -0.05570062, -0.58680656,
    0.80780907, -0.05570062, -0.58680656,
    0.91216314, -0.05599774, -0.40598357,
    0.91216314, -0.05599774, -0.40598357,
    0.97662549, -0.05570145, -0.20760542,
    0.97662549, -0.05570145, -0.20760542,
    0.99844184, -0.05580234, 0.00000000,
    0.99844184, -0.05580234, 0.00000000,
    0.97662004, -0.05580114, 0.20760425,
    0.97662004, -0.05580114, 0.20760425,
    0.91208245, -0.05579893, 0.40619217,
    0.91208245, -0.05579893, 0.40619217,
    0.80780907, -0.05570062, 0.58680656,
    0.80780907, -0.05570062, 0.58680656,
    0.66813405, -0.05590285, 0.74193784,
    0.66813405, -0.05590285, 0.74193784,
    0.49931595, -0.05570178, 0.86462760,
    0.49931595, -0.05570178, 0.86462760,
    0.30849597, -0.05579927, 0.94958764,
    0.30849597, -0.05579927, 0.94958764,
    0.10439560, -0.05599764, 0.99295812,
    0.10439560, -0.05599764, 0.99295812,
    -0.10439501, -0.05609732, 0.99295255,
    -0.10439501, -0.05609732, 0.99295255,
    -0.30861403, -0.05590254, 0.94954320,
    -0.30861403, -0.05590254, 0.94954320,
    -0.49918934, -0.05599880, 0.86468152,
    -0.49918934, -0.05599880, 0.86468152,
    -0.66819688, -0.05569974, 0.74189653,
    -0.66819688, -0.05569974, 0.74189653,
    -0.80780907, -0.05570062, 0.58680656,
    -0.80780907, -0.05570062, 0.58680656,
    -0.91208245, -0.05579893, 0.40619217,
    -0.91208245, -0.05579893, 0.40619217,
    -0.95395953, -0.22099063, 0.20279139,
    -0.90239973, -0.43089990, 0.00000000,
    -0.88268771, -0.43089400, -0.18759738,
    -0.89091830, -0.22110454, -0.39670815,
    -0.78902109, -0.22080592, -0.57331533,
    -0.65259796, -0.22119932, -0.72469771,
    -0.48761365, -0.22100619, -0.84462370,
    -0.30138787, -0.22089110, -0.92756265,
    -0.10190352, -0.22100767, -0.96993365,
    0.10190352, -0.22100767, -0.96993365,
    0.30138787, -0.22089110, -0.92756265,
    0.48762444, -0.22091107, -0.84464235,
    0.65259796, -0.22119932, -0.72469771,
    0.78895134, -0.22118637, -0.57326466,
    0.89099798, -0.22079950, -0.39669909,
    0.95393118, -0.22100722, -0.20290665,
    0.97527509, -0.22099435, 0.00000000,
    0.95395953, -0.22099063, 0.20279139,
    0.89101765, -0.22070437, 0.39670785,
    0.78902109, -0.22080592, 0.57331533,
    0.65259796, -0.22119932, 0.72469771,
    0.48762444, -0.22091107, 0.84464235,
    0.30139453, -0.22079598, 0.92758314,
    0.10189815, -0.22079600, 0.96998242,
    -0.10190352, -0.22100767, 0.96993365,
    -0.30139453, -0.22079598, 0.92758314,
    -0.48761365, -0.22100619, 0.84462370,
    -0.65257545, -0.22069170, 0.72487272,
    -0.78895134, -0.22118637, 0.57326466,
    -0.89101765, -0.22070437, 0.39670785,
    -0.88270918, -0.43080445, 0.18770195,
    -0.78468818, -0.61989069, 0.00000000,
    -0.76738911, -0.62009120, -0.16309769,
    -0.82440561, -0.43080291, -0.36710250,
    -0.73010776, -0.43070458, -0.53050564,
    -0.60379085, -0.43129347, -0.67038986,
    -0.45117726, -0.43117823, -0.78136061,
    -0.27869596, -0.43129376, -0.85808756,
    -0.09429687, -0.43108568, -0.89737018,
    0.09429687, -0.43108568, -0.89737018,
    0.27869596, -0.43129376, -0.85808756,
    0.45121980, -0.43081888, -0.78153425,
    0.60377641, -0.43118315, -0.67047382,
    0.73010776, -0.43070458, -0.53050564,
    0.82440561, -0.43080291, -0.36710250,
    0.88268771, -0.43089400, -0.18759738,
    0.90226449, -0.43118302, 0.00000000,
    0.88270918, -0.43080445, 0.18770195,
    0.82447315, -0.43068597, 0.36708803,
    0.73010776, -0.43070458, 0.53050564,
    0.60379085, -0.43129347, 0.67038986,
    0.45117726, -0.43117823, 0.78136061,
    0.27869596, -0.43129376, 0.85808756,
    0.09429687, -0.43108568, 0.89737018,
    -0.09429687, -0.43108568, 0.89737018,
    -0.27878830, -0.43108192, 0.85816401,
    -0.45111705, -0.43111632, 0.78142954,
    -0.60378798, -0.43099142, 0.67058666,
    -0.73010776, -0.43070458, 0.53050564,
    -0.82433277, -0.43101713, 0.36701461,
    -0.76738911, -0.62009120, 0.16309769,
    -0.62761756, -0.77852180, 0.00000000,
    -0.61391052, -0.77851335, -0.13050224,
    -0.71683475, -0.61993005, -0.31911547,
    -0.63481510, -0.61991472, -0.46121094,
    -0.52509499, -0.61999411, -0.58299447,
    -0.39229617, -0.61999393, -0.67949337,
    -0.24260050, -0.61970132, -0.74640155,
    -0.08190100, -0.62000751, -0.78030950,
    0.08220010, -0.61960083, -0.78060102,
    0.24260050, -0.61970132, -0.74640155,
    0.39231817, -0.61982866, -0.67963143,
    0.52517318, -0.61966842, -0.58327025,
    0.63481510, -0.61991472, -0.46121094,
    0.71683475, -0.61993005, -0.31911547,
    0.76738911, -0.62009120, -0.16309769,
    0.78468818, -0.61989069, 0.00000000,
    0.76738911, -0.62009120, 0.16309769,
    0.71683475, -0.61993005, 0.31911547,
    0.63481510, -0.61991472, 0.46121094,
    0.52519610, -0.62009539, 0.58279564,
    0.39229617, -0.61999393, 0.67949337,
    0.24258547, -0.61976287, 0.74635532,
    0.08210096, -0.62010733, 0.78020916,
    -0.08210096, -0.62010733, 0.78020916,
    -0.24258547, -0.61976287, 0.74635532,
    -0.39229850, -0.62009760, 0.67939742,
    -0.52509887, -0.61979868, 0.58319874,
    -0.63481510, -0.61991472, 0.46121094,
    -0.71683475, -0.61993005, 0.31911547,
    -0.61391052, -0.77851335, 0.13050224,
    -0.43979830, -0.89809657, 0.00000000,
    -0.43019793, -0.89809568, -0.09139956,
    -0.57371263, -0.77821706, -0.25540560,
    -0.50798741, -0.77828063, -0.36909084,
    -0.42017314, -0.77825028, -0.46667016,
    -0.31398975, -0.77827458, -0.54378223,
    -0.19409639, -0.77818545, -0.59728888,
    -0.06560022, -0.77810270, -0.62470216,
    0.06560022, -0.77810270, -0.62470216,
    0.19409639, -0.77818545, -0.59728888,
    0.31398975, -0.77827458, -0.54378223,
    0.42017314, -0.77825028, -0.46667016,
    0.50798741, -0.77828063, -0.36909084,
    0.57371263, -0.77821706, -0.25540560,
    0.61391052, -0.77851335, -0.13050224,
    0.62761756, -0.77852180, 0.00000000,
    0.61391052, -0.77851335, 0.13050224,
    0.57371263, -0.77821706, 0.25540560,
    0.50798741, -0.77828063, 0.36909084,
    0.42009080, -0.77828296, 0.46668977,
    0.31389223, -0.77838077, 0.54368654,
    0.19399664, -0.77828648, 0.59718964,
    0.06550375, -0.77824445, 0.62453569,
    -0.06550375, -0.77824445, 0.62453569,
    -0.19399664, -0.77828648, 0.59718964,
    -0.31389223, -0.77838077, 0.54368654,
    -0.42009080, -0.77828296, 0.46668977,
    -0.50798741, -0.77828063, 0.36909084,
    -0.57371263, -0.77821706, 0.25540560,
    -0.43019793, -0.89809568, 0.09139956,
    -0.22980847, -0.97323587, 0.00000000,
    -0.22471200, -0.97325199, -0.04780255,
    -0.40179357, -0.89808560, -0.17889713,
    -0.35580008, -0.89810023, -0.25850006,
    -0.29449069, -0.89797161, -0.32698964,
    -0.22000385, -0.89801571, -0.38100668,
    -0.13590467, -0.89803082, -0.41841435,
    -0.04600148, -0.89822890, -0.43711407,
    0.04600148, -0.89822890, -0.43711407,
    0.13589899, -0.89799323, -0.41849686,
    0.22000385, -0.89801571, -0.38100668,
    0.29420948, -0.89812898, -0.32681054,
    0.35580008, -0.89810023, -0.25850006,
    0.40179357, -0.89808560, -0.17889713,
    0.43019793, -0.89809568, -0.09139956,
    0.43979830, -0.89809657, 0.00000000,
    0.43019793, -0.89809568, 0.09139956,
    0.40179357, -0.89808560, 0.17889713,
    0.35580008, -0.89810023, 0.25850006,
    0.29429121, -0.89807319, 0.32689024,
    0.21989731, -0.89808903, 0.38089534,
    0.13590383, -0.89812531, 0.41821177,
    0.04599958, -0.89809176, 0.43739597,
    -0.04599958, -0.89809176, 0.43739597,
    -0.13590383, -0.89812531, 0.41821177,
    -0.21989731, -0.89808903, 0.38089534,
    -0.29429121, -0.89807319, 0.32689024,
    -0.35580008, -0.89810023, 0.25850006,
    -0.40179357, -0.89808560, 0.17889713,
    -0.22471200, -0.97325199, 0.04780255,
    -0.05999990, -0.99819838, 0.00000000,
    -0.05850061, -0.99821036, -0.01240013,
    -0.20969890, -0.97329487, -0.09339951,
    -0.18590659, -0.97323452, -0.13510480,
    -0.15370656, -0.97324157, -0.17080729,
    -0.11490453, -0.97323832, -0.19900783,
    -0.07100194, -0.97322667, -0.21860598,
    -0.02400098, -0.97333966, -0.22810930,
    0.02399879, -0.97325079, -0.22848844,
    0.07100194, -0.97322667, -0.21860598,
    0.11490453, -0.97323832, -0.19900783,
    0.15350420, -0.97332658, -0.17050465,
    0.18590659, -0.97323452, -0.13510480,
    0.20950767, -0.97333567, -0.09340342,
    0.22471200, -0.97325199, -0.04780255,
    0.22980847, -0.97323587, 0.00000000,
    0.22471200, -0.97325199, 0.04780255,
    0.20969890, -0.97329487, 0.09339951,
    0.18590659, -0.97323452, 0.13510480,
    0.15369160, -0.97324685, 0.17079067,
    0.11480380, -0.97333217, 0.19860657,
    0.07099814, -0.97327447, 0.21839428,
    0.02399864, -0.97334492, 0.22808710,
    -0.02399864, -0.97334492, 0.22808710,
    -0.07099814, -0.97327447, 0.21839428,
    -0.11480380, -0.97333217, 0.19860657,
    -0.15369160, -0.97324685, 0.17079067,
    -0.18590659, -0.97323452, 0.13510480,
    -0.20950767, -0.97333567, 0.09340342,
    -0.05850061, -0.99821036, 0.01240013,
    0.00000000, -1.00000000, 0.00000000,
    -0.05509891, -0.99818029, -0.02449951,
    -0.04859973, -0.99819437, -0.03529980,
    -0.04039896, -0.99817434, -0.04489885,
    -0.02990014, -0.99820456, -0.05190024,
    -0.01850026, -0.99821411, -0.05680080,
    -0.00630005, -0.99820839, -0.05950050,
    0.00630005, -0.99820839, -0.05950050,
    0.01850026, -0.99821411, -0.05680080,
    0.02999989, -0.99819639, -0.05199981,
    0.04039896, -0.99817434, -0.04489885,
    0.04859973, -0.99819437, -0.03529980,
    0.05509891, -0.99818029, -0.02449951,
    0.05850061, -0.99821036, -0.01240013,
    0.05999990, -0.99819838, 0.00000000,
    0.05850061, -0.99821036, 0.01240013,
    0.05509891, -0.99818029, 0.02449951,
    0.04859973, -0.99819437, 0.03529980,
    0.04019983, -0.99819579, 0.04459981,
    0.03000005, -0.99820157, 0.05190008,
    0.01859991, -0.99819520, 0.05709973,
    0.00630005, -0.99820839, 0.05950050,
    -0.00630005, -0.99820839, 0.05950050,
    -0.01859991, -0.99819520, 0.05709973,
    -0.03000005, -0.99820157, 0.05190008,
    -0.04019983, -0.99819579, 0.04459981,
    -0.04859973, -0.99819437, 0.03529980,
    -0.05509891, -0.99818029, 0.02449951,
    -0.10709772, -0.59038742, 0.79998298,
    -0.40757942, 0.65906673, 0.63206809,
    -0.13739411, 0.67397117, 0.72586894,
    -0.65009126, 0.62799158, -0.42779426,
    0.53160823, 0.54290844, -0.65011008,
    0.73970013, -0.66160011, 0.12300003,
    0.72240610, -0.66050554, -0.20460172,
    0.00890032, 0.95833434, -0.28551022,
    0.36788404, -0.91106044, -0.18609193,
    -0.34999643, -0.61729369, -0.70459279,
    -0.35010579, -0.61721020, -0.70461159,
    -0.70421858, -0.54551437, 0.45441199,
    0.42409200, -0.63398804, 0.64668782,
    -0.50958340, 0.65127877, -0.56228171,
    -0.72699257, -0.59169395, -0.34839643,
    -0.51550573, 0.55020606, -0.65690725,
    -0.12590120, 0.86410824, -0.48730467,
    0.17830569, -0.96893098, 0.17140547,
    0.17820887, -0.96894825, 0.17140853,
    0.01220000, -0.91860009, -0.39500005,
    0.01219936, -0.91865198, -0.39487936,
    0.40909456, 0.81428920, 0.41179454,
    0.51160703, -0.59170816, -0.62300859,
    -0.57008038, -0.57598017, -0.58587985,
    -0.57011322, -0.57591335, -0.58591358,
    -0.63227524, -0.59037687, 0.50168034,
    -0.73859743, -0.57229803, 0.35629876,
    0.06359899, 0.55549107, -0.82908675,
    0.25641039, -0.57662338, -0.77573139,
    0.25639559, -0.57669010, -0.77568669,
    0.50499593, 0.54999559, -0.66519468,
    0.71512221, -0.58841829, -0.37731173,
    0.57578245, 0.62418100, -0.52808395,
    0.20539437, -0.55748474, -0.80437797,
    -0.70737065, -0.63087382, -0.31878675,
    -0.73711313, -0.66261174, 0.13270235,
    -0.73715878, -0.66256292, 0.13269257,
    -0.53741311, 0.54291325, -0.64531570,
    0.69119734, 0.61419762, -0.38079852,
    0.72580307, 0.68440293, 0.06930030,
    0.68500050, 0.66070052, 0.30700023,
    0.15800186, 0.58320681, 0.79680940,
    0.09679656, -0.59217894, 0.79997158,
    0.28290236, 0.62830525, 0.72470599,
    -0.15990362, 0.58281315, 0.79671806,
    -0.72924515, 0.64203974, 0.23661463,
    -0.72929194, 0.64199295, 0.23659738,
    -0.72167802, 0.68897903, -0.06699796,
    -0.73859743, 0.57229803, 0.35629876,
    0.60119892, 0.55189909, 0.57789899,
    0.02590078, 0.54501641, -0.83802522,
    -0.63227524, 0.59037687, 0.50168034,
    0.58540929, 0.55720884, 0.58890939,
    -0.57008038, 0.57598017, -0.58587985,
    -0.57011322, 0.57591335, -0.58591358,
    0.51160703, 0.59170816, -0.62300859,
    0.42409200, 0.63398804, 0.64668782,
    0.74400288, 0.55200213, -0.37650147,
    -0.70421858, 0.54551437, 0.45441199,
    -0.34999643, 0.61729369, -0.70459279,
    -0.35010579, 0.61721020, -0.70461159,
  ]),
  materialIndex: 0,
};

const WRATH_MESH_1: RuneMesh = {
  name: "Wrath_Rune_primitive1",
  positions: new Float32Array([
    0.29960001, 0.35639998, -0.25060004,
    0.16990000, 0.35639998, -0.38510004,
    0.16990000, 0.35639998, -0.38510004,
    0.02820000, 0.35639998, -0.43550003,
    0.62379998, 0.35640004, 0.30669996,
    0.34279999, 0.35640004, 0.49159998,
    0.44130000, 0.35640004, 0.24659997,
    0.43410000, 0.35640001, 0.10969997,
    0.39080000, 0.35640001, 0.03049997,
    0.38839999, 0.35640001, -0.06560003,
    0.21310000, 0.35640001, -0.06800003,
    0.07860000, 0.35640001, 0.11449997,
    0.29240000, 0.35640001, 0.06889997,
    0.30919999, 0.35640001, 0.16019997,
    0.20829999, 0.35640004, 0.21059997,
    0.25870001, 0.35640004, 0.44359997,
    0.07140000, 0.35640004, 0.35229996,
    0.06900000, 0.35640004, 0.26589996,
    0.06900000, 0.35640004, 0.26589996,
    -0.02230000, 0.35640001, -0.00560003,
    -0.12560000, 0.35640001, 0.06889997,
    -0.16640000, 0.35640001, -0.11120003,
    -0.34169999, 0.35640001, -0.11600003,
    -0.34169999, 0.35640001, 0.01849997,
    -0.11120000, 0.35640004, 0.21299997,
    -0.02470000, 0.35640004, 0.48919997,
    -0.11600000, 0.35640004, 0.30429998,
    -0.30329999, 0.35640004, 0.40039998,
    -0.25529999, 0.35640001, 0.16499998,
    -0.34650001, 0.35640001, 0.12649997,
    -0.39460000, 0.35640001, -0.02240003,
    -0.48590001, 0.35640001, 0.06409997,
    -0.49070001, 0.35640004, 0.20339997,
    -0.38980001, 0.35640004, 0.44839996,
    -0.68040001, 0.35640004, 0.26109996,
    -0.68279999, 0.35640001, -0.01040003,
    -0.63480002, 0.35639998, -0.24820003,
    -0.49070001, 0.35639998, -0.44030002,
    -0.26010001, 0.35639998, -0.30340004,
    -0.12080000, 0.35639998, -0.44030002,
    0.53740001, 0.35639998, -0.39230004,
    0.67430001, 0.35639998, -0.20730004,
    0.67189997, 0.35640001, 0.03529998,
  ]),
  indices: new Uint16Array([
    7, 8, 9, 9, 10, 2, 0, 40, 41, 9, 2, 0,
    9, 0, 41, 41, 42, 4, 4, 5, 6, 7, 9, 41,
    4, 6, 7, 7, 41, 4, 14, 15, 16, 14, 16, 18,
    8, 13, 14, 12, 9, 8, 1, 10, 11, 12, 8, 14,
    3, 1, 11, 11, 12, 14, 19, 20, 21, 11, 14, 18,
    19, 21, 3, 11, 18, 19, 19, 3, 11, 32, 33, 34,
    34, 35, 36, 36, 37, 38, 38, 39, 3, 3, 21, 22,
    38, 3, 22, 34, 36, 38, 31, 32, 34, 28, 29, 30,
    31, 34, 38, 30, 31, 38, 30, 38, 22, 26, 27, 28,
    30, 22, 23, 20, 19, 24, 28, 30, 23, 23, 20, 24,
    24, 17, 16, 16, 25, 26, 26, 28, 23, 24, 16, 26,
    23, 24, 26,
  ]),
  normals: new Float32Array([
    -0.10710404, -0.59032232, 0.80003018,
    -0.40757942, 0.65906673, 0.63206809,
    -0.40760627, 0.65901016, 0.63210975,
    -0.13739411, 0.67397117, 0.72586894,
    -0.65009126, 0.62799158, -0.42779426,
    0.53160823, 0.54290844, -0.65011008,
    0.73970013, -0.66160011, 0.12300003,
    0.72240610, -0.66050554, -0.20460172,
    0.00890032, 0.95833434, -0.28551022,
    0.36779756, -0.91109396, -0.18609877,
    -0.34999643, -0.61729369, -0.70459279,
    -0.70426898, -0.54547595, 0.45438000,
    0.42409200, -0.63398804, 0.64668782,
    -0.50958340, 0.65127877, -0.56228171,
    -0.72699257, -0.59169395, -0.34839643,
    -0.51550573, 0.55020606, -0.65690725,
    -0.12590120, 0.86410824, -0.48730467,
    0.17830569, -0.96893098, 0.17140547,
    0.17820887, -0.96894825, 0.17140853,
    0.01220048, -0.91863638, -0.39491561,
    0.40909456, 0.81428920, 0.41179454,
    0.51160703, -0.59170816, -0.62300859,
    -0.57018072, -0.57588053, -0.58588016,
    -0.63231258, -0.59031175, 0.50170992,
    -0.73859743, -0.57229803, 0.35629876,
    0.06359899, 0.55549107, -0.82908675,
    0.25639049, -0.57657864, -0.77577123,
    0.50499593, 0.54999559, -0.66519468,
    0.71517108, -0.58837621, -0.37728473,
    0.57578245, 0.62418100, -0.52808395,
    0.20539437, -0.55748474, -0.80437797,
    -0.70739317, -0.63089395, -0.31869692,
    -0.73715878, -0.66256292, 0.13269257,
    -0.53741311, 0.54291325, -0.64531570,
    0.69119734, 0.61419762, -0.38079852,
    0.72570608, 0.68450574, 0.06930058,
    0.68500050, 0.66070052, 0.30700023,
    0.15800186, 0.58320681, 0.79680940,
    0.09679656, -0.59217894, 0.79997158,
    0.28290236, 0.62830525, 0.72470599,
    -0.15990362, 0.58281315, 0.79671806,
    -0.72924515, 0.64203974, 0.23661463,
    -0.72167802, 0.68897903, -0.06699796,
  ]),
  materialIndex: 1,
};

const WRATH_MESH_2: RuneMesh = {
  name: "Wrath_Rune_primitive2",
  positions: new Float32Array([
    -0.11120000, 0.40350002, 0.21299997,
    0.06900000, 0.40350002, 0.26589996,
    -0.02230000, 0.40349999, -0.00560003,
    -0.34169999, 0.40349999, 0.01849997,
    -0.12560000, 0.40349999, 0.06889997,
    -0.34169999, 0.40349999, -0.11600003,
    -0.16640000, 0.40349999, -0.11120003,
    0.29240000, 0.40349999, 0.06889997,
    0.38839999, 0.40349999, -0.06560003,
    0.07860000, 0.40349999, 0.11449997,
    0.21310000, 0.40349999, -0.06800003,
  ]),
  indices: new Uint16Array([
    6, 4, 3, 6, 3, 5, 7, 9, 10, 7, 10, 8,
    2, 1, 0,
  ]),
  normals: new Float32Array([
    -0.73859743, 0.57229803, 0.35629876,
    0.60123369, 0.55193099, 0.57783236,
    0.02589937, 0.54508670, -0.83797954,
    -0.63227524, 0.59037687, 0.50168034,
    0.58540929, 0.55720884, 0.58890939,
    -0.57011322, 0.57591335, -0.58591358,
    0.51160703, 0.59170816, -0.62300859,
    0.42409200, 0.63398804, 0.64668782,
    0.74400288, 0.55200213, -0.37650147,
    -0.70426898, 0.54547595, 0.45438000,
    -0.35001803, 0.61723180, -0.70463628,
  ]),
  materialIndex: 2,
};

export const WRATH_MESHES: RuneMesh[] = [
  WRATH_MESH_0,
  WRATH_MESH_1,
  WRATH_MESH_2,
];
